webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    setLoading: function setLoading(val) {
      this.$emit('admin.loading', !!val);
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventEmitter__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    notify: function notify(msg) {
      __WEBPACK_IMPORTED_MODULE_0__services_EventEmitter__["a" /* default */].$emit('admin.notify', msg);
    },
    notifyError: function notifyError(msg) {
      __WEBPACK_IMPORTED_MODULE_0__services_EventEmitter__["a" /* default */].$emit('admin.notify-error', msg);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  serialize: function serialize(obj, prefix) {
    var str = [];
    var k = '';
    var v = null;
    for (var p in obj) {
      if (obj.hasOwnProperty(p)) {
        k = prefix ? prefix + '[' + p + ']' : p;
        v = obj[p];
        str.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    }
    return str.join('&');
  },
  paginate: function paginate(url, meta) {
    var important = {
      page: meta.current_page,
      limit: meta.per_page,
      sort: meta.sort,
      direction: meta.direction
    };
    if (meta.filter) {
      for (var p in meta.filter) {
        if (meta.filter.hasOwnProperty(p)) {
          important[p] = meta.filter[p];
        }
      }
    }

    var path = this.serialize(important);
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(url + '?' + path);
  },
  errorMessages: function errorMessages(keys) {
    var base = {
      required: 'To pole jest wymagane',
      min: 'Zbyt mała liczba znaków',
      max: 'Zbyt duża liczba znaków',
      numeric: 'Wpisz numer',
      email: 'Wpisz poprawny e-mail'
    };
    var ret = {};
    for (var i = 0; i < keys.length; i++) {
      ret[keys[i]] = base[keys[i]];
    }

    return ret;
  },
  isFunction: function isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
  },
  multiselectToIds: function multiselectToIds(val) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

    return val.map(function (v) {
      return v[key];
    });
  },
  keysForSelect: function keysForSelect() {
    return {
      label: 'name',
      value: 'id'
    };
  },
  convertNulls: function convertNulls(keys, item) {
    for (var key in item) {
      if (item.hasOwnProperty(key)) {
        // is null
        if (item[key] === null && keys.indexOf(key) !== -1) {
          item[key] = '';
        }
      }
    }
    return item;
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


var key = 'i-admin-token';

/* harmony default export */ __webpack_exports__["a"] = ({
  domain: window.NEWSLETTER_SERVER || 'http://localhost:8010',
  user: null,
  token: null,
  login: function login(credentials) {
    var url = this.getUrl('login');
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(url, credentials);
  },
  getUrl: function getUrl(url) {
    return this.domain + '/' + url;
  },
  changePassword: function changePassword(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post('my/change-password', data);
  },
  clearToken: function clearToken() {
    this.token = null;
    this.saveToken(this.token);
  },
  my: function my() {
    var url = this.getUrl('my');
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(url);
  },
  getTokenFromStorage: function getTokenFromStorage() {
    this.token = localStorage.getItem(key);
    return this.token;
  },
  saveToken: function saveToken(token) {
    localStorage.setItem(key, token);
    this.setTokenForAllRequests(token);
  },
  setTokenForAllRequests: function setTokenForAllRequests(token) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.headers.Authorization = 'Bearer ' + token;
  },
  setDefaultHeaders: function setDefaultHeaders() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = this.domain;
    if (!__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.headers) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.headers = {};
    }
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.headers['Accept'] = 'application/json, text/plain, */*';
  },
  setInterceptors: function setInterceptors(router) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
      // modify request
      // console.log(request);
      // continue to next interceptor
      next(function (response) {
        // modify response
        // response.body = '...';
        // console.log(response);
        if (response.status === 401) {
          router.push({
            name: 'login'
          });
        }
      });
    });
  },
  setUser: function setUser(user) {
    this.user = user;
  },
  getUser: function getUser() {
    return this.user;
  }
});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errors: []
    };
  },

  methods: {
    getResponseErrors: function getResponseErrors(res) {
      var errors = [];
      if (res.status === 422) {
        if (res.data) {
          for (var i in res.data) {
            for (var e in res.data[i]) {
              errors.push(res.data[i][e]);
            }
          }
        }
      }
      return errors;
    },
    joinErrorsToMsg: function joinErrorsToMsg(errors) {
      var msg = '';
      for (var e in errors) {
        msg = msg + errors[e] + '. ';
      }
      return msg;
    }
  },
  dismissErrors: function dismissErrors() {
    this.errors = [];
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].getUrl('email-group'),
  paginate: function paginate(meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url, meta);
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id);
  },
  signupPagePreviewUrl: function signupPagePreviewUrl(id) {
    return __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].domain + '/email-group/' + id + '/signup-page';
  },
  names: function names() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/names');
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url, data);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(this.url + '/' + data.id, data);
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(this.url + '/' + id);
  },
  inGroup: function inGroup(id, meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate('email/emails-in-group/' + id, meta);
  },
  statuses: function statuses() {
    return [{ id: 1, name: 'Aktywna' }, { id: 2, name: 'Nie aktywna' }];
  },
  getBaseItem: function getBaseItem() {
    return {
      id: null,
      name: '',
      email_account_id: -1,
      public: true,
      status: 1,

      user_agree: false,
      user_agree_url: '',
      user_agree_label: '',
      user_agree_text: '',

      user_agree2: false,
      user_agree2_url: '',
      user_agree2_label: '',
      user_agree2_text: '',

      form_title: 'Zapisz się na newsletter',
      form_html_body: '',
      form_submit_btn: 'Zapisz się',
      confirm_email_body: '',
      success_msg: 'Zapisałeś się',
      success_signup_template_html: null,
      success_signup_template_text: null,
      confirm_page_template: null
    };
  },
  convertNulls: function convertNulls(item) {
    var keys = ['confirm_email_body', 'form_html_body', 'form_submit_btn', 'form_title', 'user_agree2_label', 'user_agree2_text', 'user_agree2_url', 'user_agree_label', 'user_agree_text', 'user_agree_url'];
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].convertNulls(keys, item);
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].getUrl('email-account'),
  paginate: function paginate(meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url, meta);
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id);
  },
  test: function test(id, message) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url + '/' + id + '/test', message);
  },
  names: function names() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/names');
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url, data);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(this.url + '/' + data.id, data);
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(this.url + '/' + id);
  },
  getBaseItem: function getBaseItem() {
    return {
      id: null,
      name: '',
      host: '',
      port: 587,
      from_address: '',
      from_name: '',
      encryption: '',
      username: '',
      password: '',
      limit: 100,
      is_default: true,
      status: 1
    };
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].getUrl('message'),
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id);
  },
  preview: function preview(id, type) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id + '/preview/' + type);
  },
  paginate: function paginate(meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url, meta);
  },
  paginateSendLog: function paginateSendLog(id, meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url + '/' + id + '/send-log', meta);
  },
  paginateSendTo: function paginateSendTo(id, meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url + '/' + id + '/paginate-to-send', meta);
  },
  toSendTotal: function toSendTotal(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id + '/to-send-total');
  },
  test: function test(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url + '/' + id + '/test', data);
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url, data);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(this.url + '/' + data.id, data);
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(this.url + '/' + id);
  },
  statuses: function statuses() {
    return [{
      id: 1,
      name: 'Szkic'
    }, {
      id: 2,
      name: 'Przeznaczona do wysłania'
    }];
  },
  allStatuses: function allStatuses() {
    return [{
      id: 1,
      name: 'Szkic'
    }, {
      id: 2,
      name: 'Przeznaczona do wysłania'
    }, {
      id: 3,
      name: 'W trakcie wysyłania'
    }, {
      id: 4,
      name: 'Wysłana'
    }];
  },
  getBaseItem: function getBaseItem() {
    return {
      id: null,
      title: '',
      text_body: '',
      html_body: '',
      email_account_id: null,
      template_html: null,
      template_text: null,
      email_groups_ids: [],
      status: 1,
      use_template: true,
      send_to_all: true,
      send_to_confirmed: true,
      send_to_notconfirmed: false,
      send_to_imported: false,
      send_to_signout: false,
      import_html_url: null
    };
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      meta: {
        current_page: 1,
        last_page: 0,
        total: 0,
        per_page: 10,
        sort: 'id',
        direction: 'desc',
        limits: [10, 20, 50, 100, 500],
        filter: {}
      },
      items: []
    };
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    getService: function getService() {
      throw Error('You must implement getService()');
    },
    reload: function reload() {
      this.paginate(this.meta);
    },
    changeOrder: function changeOrder(key, direction) {
      this.meta.sort = key;
      this.meta.direction = direction;
      this.reload();
    },
    paginate: function paginate(meta) {
      this.setLoading(true);
      this.getService().paginate(meta).then(this.successPaginate, this.errorPaginate);
    },
    changePage: function changePage(page) {
      this.meta.current_page = page;
      this.paginate(this.meta);
    },
    changeLimit: function changeLimit(limit) {
      this.meta.per_page = limit;
      this.meta.current_page = 1;
      this.paginate(this.meta);
    },
    errorPaginate: function errorPaginate() {
      this.setLoading(false);
    },
    successPaginate: function successPaginate(res) {
      this.items = res.data.items;
      var filter = this.meta.filter;
      this.meta = res.data.meta;
      this.meta.filter = filter;
      this.setLoading(false);
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].getUrl('email'),
  paginate: function paginate(meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url, meta);
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id);
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url, data);
  },
  import: function _import(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url + '/import', data);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(this.url + '/' + data.id, data);
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(this.url + '/' + id);
  },
  getExportUrl: function getExportUrl(separator, groups) {
    var path = __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].serialize({
      separator: separator,
      groups: groups
    });
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/export/url' + '?' + path);
  },
  statuses: function statuses() {
    return [{
      id: 1,
      name: 'Aktywna'
    }, {
      id: 2,
      name: 'Nie aktywna'
    }];
  },
  separators: function separators() {
    return [{
      id: '\t',
      name: 'Tabulator'
    }, {
      id: ';',
      name: 'Średnik'
    }, {
      id: '|',
      name: 'znak "|"'
    }];
  },
  getBaseItem: function getBaseItem() {
    return {
      id: null,
      email: '',
      status: 1
    };
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].getUrl('template'),
  paginate: function paginate(meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url, meta);
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id);
  },
  names: function names() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/names');
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url, data);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(this.url + '/' + data.id, data);
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(this.url + '/' + id);
  },
  getBaseItem: function getBaseItem() {
    return {
      id: null,
      name: '',
      template_type: 'html',
      // code: '',
      body: '',
      is_layout: true,
      status: 1
    };
  },
  templateTypes: function templateTypes() {
    return [{
      name: 'Html',
      id: 'html'
    }, {
      name: 'Tekstowy',
      id: 'text'
    }];
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Auth__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_2__Auth__["a" /* default */].getUrl('user'),
  paginate: function paginate(meta) {
    return __WEBPACK_IMPORTED_MODULE_1__Utils__["a" /* default */].paginate(this.url, meta);
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/' + id);
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(this.url, data);
  },
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(this.url + '/' + data.id, data);
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(this.url + '/' + id);
  },
  getBaseItem: function getBaseItem() {
    return {
      id: null,
      email: '',
      first_name: '',
      last_name: '',
      status: 1,
      password: '',
      password2: ''
    };
  }
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return adminMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emailsMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newslettersMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return myMenu; });
var adminMenu = [{
  id: 'users',
  text: 'Administratorzy',
  route: 'admin.users.dashboard'
}, {
  id: 'templates',
  text: 'Szablony',
  route: 'admin.templates.dashboard'
}, {
  id: 'accounts',
  text: 'Konto do wysyłania',
  route: 'admin.accounts.dashboard'
}];

var emailsMenu = [{
  id: 'emails',
  text: 'Adresy e-mail',
  route: 'admin.emails.dashboard'
}, {
  id: 'email-groups',
  text: 'Grupy',
  route: 'admin.email-groups.dashboard'
}];

var newslettersMenu = [{
  id: 'messages',
  text: 'Wiadomości',
  route: 'admin.messages.dashboard'
}];

var myMenu = [{
  id: 'my',
  text: 'Twój profil',
  route: 'admin.my'
}, {
  id: 'logout',
  text: 'Wyloguj się',
  route: 'logout'
}];

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagination__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templates__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accounts__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__email_groups__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emails__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_upload_component__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_upload_component__);









// import SmartTable from 'vue-smart-table'


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    // Vue.component('smart-table', SmartTable)
    Vue.component('file-upload', __WEBPACK_IMPORTED_MODULE_7_vue_upload_component___default.a);

    var modules = [__WEBPACK_IMPORTED_MODULE_0__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__users__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__templates__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__accounts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__email_groups__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__emails__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__messages__["a" /* default */]];

    modules.map(function (m) {
      m.install(Vue);
    });
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Logout_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard_vue__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Layout_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_Layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_Layout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_my_My_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_my_My_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_my_My_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_my_ChangePassword_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_my_ChangePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_my_ChangePassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__templates__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__accounts__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__emailGroups__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emails__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__messages__ = __webpack_require__(46);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Home_vue___default.a,
  name: 'home'
}, {
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_3__components_auth_Login_vue___default.a,
  name: 'login'
}, {
  path: '/logout',
  component: __WEBPACK_IMPORTED_MODULE_4__components_auth_Logout_vue___default.a,
  name: 'logout'
}, {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_6__components_admin_Layout_vue___default.a,
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard_vue___default.a,
    name: 'admin.home'
  }, {
    path: 'my',
    name: 'admin.my',
    component: __WEBPACK_IMPORTED_MODULE_7__components_my_My_vue___default.a
  }, {
    path: 'change-password',
    name: 'admin.change-password',
    component: __WEBPACK_IMPORTED_MODULE_8__components_my_ChangePassword_vue___default.a
  }, __WEBPACK_IMPORTED_MODULE_10__users__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__templates__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__accounts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__emailGroups__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__emails__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__messages__["a" /* default */]]
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Panel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItem_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ListItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItemTitle_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListItemTitle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ListItemTitle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tree_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tree_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TreeSelected_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TreeSelected_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TreeSelected_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImportantLine_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImportantLine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ImportantLine_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ISelectSimple_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ISelectSimple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ISelectSimple_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ISelectMultiple_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ISelectMultiple_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ISelectMultiple_vue__);










/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('list', __WEBPACK_IMPORTED_MODULE_1__List_vue___default.a);
    Vue.component('list-item', __WEBPACK_IMPORTED_MODULE_2__ListItem_vue___default.a);
    Vue.component('list-item-title', __WEBPACK_IMPORTED_MODULE_3__ListItemTitle_vue___default.a);
    Vue.component('panel', __WEBPACK_IMPORTED_MODULE_0__Panel_vue___default.a);
    Vue.component('tree', __WEBPACK_IMPORTED_MODULE_4__Tree_vue___default.a);
    Vue.component('tree-selected', __WEBPACK_IMPORTED_MODULE_5__TreeSelected_vue___default.a);
    Vue.component('important-line', __WEBPACK_IMPORTED_MODULE_6__ImportantLine_vue___default.a);
    Vue.component('i-select', __WEBPACK_IMPORTED_MODULE_7__ISelectSimple_vue___default.a);
    Vue.component('i-select-multiple', __WEBPACK_IMPORTED_MODULE_8__ISelectMultiple_vue___default.a);
  }
});

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(285),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TestForm_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TestForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TestForm_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('accounts-list', __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a);
    Vue.component('accounts-form', __WEBPACK_IMPORTED_MODULE_1__Form_vue___default.a);
    Vue.component('accounts-test-form', __WEBPACK_IMPORTED_MODULE_2__TestForm_vue___default.a);
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('email-groups-list', __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a);
    Vue.component('email-groups-form', __WEBPACK_IMPORTED_MODULE_1__Form_vue___default.a);
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailStatus_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EmailStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__EmailStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filters_vue__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Filters_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Filters_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('emails-list', __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a);
    Vue.component('emails-form', __WEBPACK_IMPORTED_MODULE_1__Form_vue___default.a);
    Vue.component('email-status', __WEBPACK_IMPORTED_MODULE_2__EmailStatus_vue___default.a);
    Vue.component('email-filters', __WEBPACK_IMPORTED_MODULE_3__Filters_vue___default.a);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SendToList_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SendToList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SendToList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendLog_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SendLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Form_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageStatus_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MessageStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UrlPreviewForm_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UrlPreviewForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UrlPreviewForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TestForm_vue__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TestForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TestForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SendTo_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SendTo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SendTo_vue__);









/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('messages-list', __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a);
    Vue.component('messages-send-to-list', __WEBPACK_IMPORTED_MODULE_1__SendToList_vue___default.a);
    Vue.component('messages-send-log', __WEBPACK_IMPORTED_MODULE_2__SendLog_vue___default.a);
    Vue.component('messages-form', __WEBPACK_IMPORTED_MODULE_3__Form_vue___default.a);
    Vue.component('message-status', __WEBPACK_IMPORTED_MODULE_4__MessageStatus_vue___default.a);
    Vue.component('url-preview-form', __WEBPACK_IMPORTED_MODULE_5__UrlPreviewForm_vue___default.a);
    Vue.component('message-test-form', __WEBPACK_IMPORTED_MODULE_6__TestForm_vue___default.a);
    Vue.component('message-send-to-info', __WEBPACK_IMPORTED_MODULE_7__SendTo_vue___default.a);
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Basic_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Basic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Basic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sorting_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sorting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sorting_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('basic-pagination', __WEBPACK_IMPORTED_MODULE_0__Basic_vue___default.a);
    Vue.component('sorting', __WEBPACK_IMPORTED_MODULE_1__Sorting_vue___default.a);
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('templates-list', __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a);
    Vue.component('templates-form', __WEBPACK_IMPORTED_MODULE_1__Form_vue___default.a);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('users-list', __WEBPACK_IMPORTED_MODULE_0__List_vue___default.a);
    Vue.component('users-form', __WEBPACK_IMPORTED_MODULE_1__Form_vue___default.a);
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keen_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keen_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keen_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_ckeditor__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_ckeditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_ckeditor__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ckeditor', __WEBPACK_IMPORTED_MODULE_8__ui_ckeditor___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_keen_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__ui__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__services_Auth__["a" /* default */].setDefaultHeaders();
var token = __WEBPACK_IMPORTED_MODULE_7__services_Auth__["a" /* default */].getTokenFromStorage();

if (token) {
  __WEBPACK_IMPORTED_MODULE_7__services_Auth__["a" /* default */].setTokenForAllRequests(token);
}
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_accounts_Dashboard_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_accounts_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_accounts_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_accounts_Show_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_accounts_Show_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_accounts_Show_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_Create_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accounts_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_accounts_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounts_Edit_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accounts_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_accounts_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_accounts_Test_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_accounts_Test_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_accounts_Test_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Root_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Root_vue__);






/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'accounts',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Root_vue___default.a,
  children: [{
    path: '',
    name: 'admin.accounts.dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__components_accounts_Dashboard_vue___default.a
  }, {
    path: ':id/show',
    name: 'admin.accounts.show',
    component: __WEBPACK_IMPORTED_MODULE_1__components_accounts_Show_vue___default.a
  }, {
    path: 'create',
    name: 'admin.accounts.create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_accounts_Create_vue___default.a
  }, {
    path: ':id/update',
    name: 'admin.accounts.edit',
    component: __WEBPACK_IMPORTED_MODULE_3__components_accounts_Edit_vue___default.a
  }, {
    path: ':id/test',
    name: 'admin.accounts.test',
    component: __WEBPACK_IMPORTED_MODULE_4__components_accounts_Test_vue___default.a
  }]
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_email_groups_Dashboard_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_email_groups_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_email_groups_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_email_groups_Show_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_email_groups_Show_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_email_groups_Show_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_email_groups_Create_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_email_groups_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_email_groups_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_email_groups_Edit_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_email_groups_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_email_groups_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Root_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'email-groups',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default.a,
  children: [{
    path: '',
    name: 'admin.email-groups.dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__components_email_groups_Dashboard_vue___default.a
  }, {
    path: ':id/show',
    name: 'admin.email-groups.show',
    component: __WEBPACK_IMPORTED_MODULE_1__components_email_groups_Show_vue___default.a
  }, {
    path: 'create',
    name: 'admin.email-groups.create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_email_groups_Create_vue___default.a
  }, {
    path: ':id/update',
    name: 'admin.email-groups.edit',
    component: __WEBPACK_IMPORTED_MODULE_3__components_email_groups_Edit_vue___default.a
  }]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_emails_Dashboard_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_emails_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_emails_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_emails_Show_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_emails_Show_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_emails_Show_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emails_Create_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emails_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_emails_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_emails_Import_vue__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_emails_Import_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_emails_Import_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emails_ExportEmails_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_emails_ExportEmails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_emails_ExportEmails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emails_Edit_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emails_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_emails_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Root_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Root_vue__);







/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'email',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Root_vue___default.a,
  children: [{
    path: '',
    name: 'admin.emails.dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__components_emails_Dashboard_vue___default.a
  }, {
    path: ':id/show',
    name: 'admin.emails.show',
    component: __WEBPACK_IMPORTED_MODULE_1__components_emails_Show_vue___default.a
  }, {
    path: 'create',
    name: 'admin.emails.create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_emails_Create_vue___default.a
  }, {
    path: 'import',
    name: 'admin.emails.import',
    component: __WEBPACK_IMPORTED_MODULE_3__components_emails_Import_vue___default.a
  }, {
    path: 'export',
    name: 'admin.emails.export-emails',
    component: __WEBPACK_IMPORTED_MODULE_4__components_emails_ExportEmails_vue___default.a
  }, {
    path: ':id/update',
    name: 'admin.emails.edit',
    component: __WEBPACK_IMPORTED_MODULE_5__components_emails_Edit_vue___default.a
  }]
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_messages_Dashboard_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_messages_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_messages_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_messages_Show_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_messages_Show_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_messages_Show_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_messages_Create_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_messages_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_messages_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_messages_Edit_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_messages_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_messages_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Root_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'messages',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default.a,
  children: [{
    path: '',
    name: 'admin.messages.dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__components_messages_Dashboard_vue___default.a
  }, {
    path: ':id/show',
    name: 'admin.messages.show',
    component: __WEBPACK_IMPORTED_MODULE_1__components_messages_Show_vue___default.a
  }, {
    path: 'create',
    name: 'admin.messages.create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_messages_Create_vue___default.a
  }, {
    path: ':id/update',
    name: 'admin.messages.edit',
    component: __WEBPACK_IMPORTED_MODULE_3__components_messages_Edit_vue___default.a
  }]
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_templates_Dashboard_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_templates_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_templates_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_Show_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_templates_Show_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_templates_Show_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_templates_Create_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_templates_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_templates_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_Edit_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Root_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'templates',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default.a,
  children: [{
    path: '',
    name: 'admin.templates.dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__components_templates_Dashboard_vue___default.a
  }, {
    path: ':id/show',
    name: 'admin.templates.show',
    component: __WEBPACK_IMPORTED_MODULE_1__components_templates_Show_vue___default.a
  }, {
    path: 'create',
    name: 'admin.templates.create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_templates_Create_vue___default.a
  }, {
    path: ':id/update',
    name: 'admin.templates.edit',
    component: __WEBPACK_IMPORTED_MODULE_3__components_templates_Edit_vue___default.a
  }]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_users_Dashboard_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_users_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_users_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_Show_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_users_Show_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_users_Show_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_Create_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_users_Create_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_users_Create_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_Edit_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_users_Edit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_users_Edit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Root_vue__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'users',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Root_vue___default.a,
  children: [{
    path: '',
    name: 'admin.users.dashboard',
    component: __WEBPACK_IMPORTED_MODULE_0__components_users_Dashboard_vue___default.a
  }, {
    path: ':id/show',
    name: 'admin.users.show',
    component: __WEBPACK_IMPORTED_MODULE_1__components_users_Show_vue___default.a
  }, {
    path: 'create',
    name: 'admin.users.create',
    component: __WEBPACK_IMPORTED_MODULE_2__components_users_Create_vue___default.a
  }, {
    path: ':id/update',
    name: 'admin.users.edit',
    component: __WEBPACK_IMPORTED_MODULE_3__components_users_Edit_vue___default.a
  }]
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Adm-newsletter'
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Auth__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  url: __WEBPACK_IMPORTED_MODULE_1__Auth__["a" /* default */].getUrl('curl'),
  get: function get(url) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.url + '/get?url=' + url);
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    // wywolaj /api/my aby sprawdzic czy login działa

    __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].my().then(function (res) {
      __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].setUser(res.data.user);
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('user.get', res.data.user);
    }, function () {
      _this.$router.push({
        name: 'login'
      });
    });
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Config__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      msg: __WEBPACK_IMPORTED_MODULE_0__services_Config__["a" /* default */].name + '. Witaj, prosimy się zalogować'
    };
  },

  methods: {
    goLogin: function goLogin() {
      this.$router.push({ name: 'login' });
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Accounts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      modal: {
        show: false,
        title: 'Dodaj konto',
        baseCreateTitle: 'Dodaj konto',
        baseUpdateTitle: 'Edytuj konto'
      },
      item: __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].getBaseItem()
    };
  },

  methods: {
    onAccountsChange: function onAccountsChange(e) {
      this.modal.show = false;
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('accounts.reload', e);
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getItem(id);
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'admin.accounts.dashboard', params: { id: this.item.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Accounts__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_FormErrors__["a" /* default */]],
  props: ['item'],
  data: function data() {
    return {
      errors: [],
      title: 'Dodaj konto do wysyłania',
      action: 'Dodaj konto do wysyłania',
      errorMessages: __WEBPACK_IMPORTED_MODULE_4__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    if (this.item.id) {
      this.title = 'Aktualizuj konto do wysyłania';
      this.action = 'Aktualizuj konto do wysyłania';
    }
  },

  methods: {
    resetForm: function resetForm() {
      this.item = __WEBPACK_IMPORTED_MODULE_5__services_Accounts__["a" /* default */].getBaseItem();
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy');
    },
    success: function success(res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('accounts.update', this.item);
          this.notify('Zmieniłeś konto do wysyłania');
          this.$router.push({ name: 'admin.accounts.show', params: { id: this.item.id } });
        }
      } else {
        if (res.status === 201) {
          this.$emit('accounts.create', this.item);
          this.notify('Dodałeś konto do wysyłania');
          this.$router.push({ name: 'admin.accounts.show', params: { id: res.data.item.id } });
        }
      }
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);

      var item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      if (this.item.id) {
        item.id = this.item.id;
      }

      if (this.item.id) {
        __WEBPACK_IMPORTED_MODULE_5__services_Accounts__["a" /* default */].update(item).then(this.success, this.error);
      } else {
        __WEBPACK_IMPORTED_MODULE_5__services_Accounts__["a" /* default */].create(item).then(this.success, this.error);
      }
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  methods: {
    getService: function getService() {
      return __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */];
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.reload();
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('accounts.reload', function () {
      _this3.meta.current_page = 1;
      _this3.reload();
    });
  }
  // events: {
  //   'accounts.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }

});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      showPassword: false,
      item: __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].getBaseItem(),
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.getItem(this.id);
  },

  methods: {
    edit: function edit() {
      this.$router.push({ name: 'admin.accounts.edit', params: { id: this.id } });
    },
    test: function test() {
      this.$router.push({ name: 'admin.accounts.test', params: { id: this.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      showPassword: false,
      item: __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].getBaseItem(),
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.getItem(this.id);
  },

  methods: {
    edit: function edit() {
      this.$router.push({ name: 'admin.accounts.edit', params: { id: this.id } });
    },
    test: function test() {
      this.$router.push({ name: 'admin.accounts.test', params: { id: this.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Accounts__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_FormErrors__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var simpleHtml = '<html><head></head><body><h2>Witaj!</h2><p>To jest <strong>prosta</strong> wiadomość html!</p></body>';
var simpleText = 'Witaj\n\nTo jest prosta wiadomość tekstowa!';
var simpleTitle = 'To jest prosta wiadomość!';

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_FormErrors__["a" /* default */]],
  props: ['item'],
  data: function data() {
    return {
      errors: [],
      simpleTitle: simpleTitle,
      simpleHtml: simpleHtml,
      simpleText: simpleText,
      errorMessages: __WEBPACK_IMPORTED_MODULE_0__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email']),
      message: {
        title: '',
        send_to: '',
        text_body: '',
        html_body: ''
      }
    };
  },

  methods: {
    fill: function fill() {
      this.message.title = this.simpleTitle;
      this.message.text_body = this.simpleText;
      this.message.html_body = this.simpleHtml;
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy przy wysłaniu wiadomości, sprawdź dane do konta smtp');
    },
    success: function success() {
      this.notify('Wysłano poprawnie tą wiadomość. Konto smtp wysyła wiadomości');
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);
      __WEBPACK_IMPORTED_MODULE_1__services_Accounts__["a" /* default */].test(this.item.id, this.message).then(this.success, this.error);
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      newslettersMenu: __WEBPACK_IMPORTED_MODULE_0__index__["a" /* newslettersMenu */],
      emailsMenu: __WEBPACK_IMPORTED_MODULE_0__index__["b" /* emailsMenu */],
      adminMenu: __WEBPACK_IMPORTED_MODULE_0__index__["c" /* adminMenu */],
      myMenu: __WEBPACK_IMPORTED_MODULE_0__index__["d" /* myMenu */]
    };
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftMenu_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LeftMenu_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { LeftMenu: __WEBPACK_IMPORTED_MODULE_3__LeftMenu_vue___default.a },
  data: function data() {
    return {
      preloaderTop: true,
      loading: false,
      showBrand: true,
      flat: true,
      hideNavIcon: false,
      menuLeft: true,
      title: 'Adm-newsletter',
      user: {
        email: null,
        id: null
      },
      leftMenuItems: [{ header: 'Wiadomości e-mail', items: __WEBPACK_IMPORTED_MODULE_2__index__["a" /* newslettersMenu */] }, { header: 'Subskrybenci', items: __WEBPACK_IMPORTED_MODULE_2__index__["b" /* emailsMenu */] }, { header: 'Administracja', items: __WEBPACK_IMPORTED_MODULE_2__index__["c" /* adminMenu */] }, { header: 'Twój profil', items: __WEBPACK_IMPORTED_MODULE_2__index__["d" /* myMenu */] }],
      position: 'right',
      queueSnackbars: true,
      allowHtml: true,
      action: '',
      duration: 5,
      actionColor: 'accent',
      message: '',
      baseConfirmTitle: 'Napewno?',
      confirm: {
        show: false,
        confirm: 'Napewno?',
        message: 'Jesteś pewien? Ta operacja jest nieodwracalna',
        confirmButton: 'Usuń',
        denyButton: 'Anuluj',
        confirmCb: function confirmCb() {},
        denyCb: function denyCb() {}
      }
    };
  },

  methods: {
    toggle: function toggle() {
      this.loading = !this.loading;
    },
    selectMenuItem: function selectMenuItem(e) {
      this.$router.push({
        name: e.route,
        params: {}
      });
    },
    setLoading: function setLoading(val) {
      this.loading = !!val;
    },
    confirmed: function confirmed() {
      if (__WEBPACK_IMPORTED_MODULE_0__services_Utils__["a" /* default */].isFunction(this.confirm.confirmCb)) {
        this.confirm.confirmCb(true);
      }
      this.show = false;
    },
    navIconClick: function navIconClick() {
      this.menuLeft = !this.menuLeft;
    },
    denied: function denied() {
      if (__WEBPACK_IMPORTED_MODULE_0__services_Utils__["a" /* default */].isFunction(this.confirm.denyCb)) {
        this.confirm.denyCb(false);
      }
    },
    notify: function notify(msg) {
      this.$refs.snackbarContainer.createSnackbar({
        message: msg,
        action: null,
        actionColor: this.actionColor,
        duration: this.duration * 1000
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('user.get', function (user) {
      _this.user = user;
    });
    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('admin.loading', function (val) {
      _this.setLoading(val);
    });
    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('confirm.show', function (e) {
      _this.confirm.confirmCb = e.confirmCb ? e.confirmCb : function () {};
      _this.confirm.denyCb = e.denyCb ? e.denyCb : function () {};
      _this.confirm.show = true;
      _this.confirm.title = e.title || _this.baseConfirmTitle;
      _this.$refs.confirm1.open();
    });
    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('admin.notify', this.notify);
    // TODO nie ma error toast w keen ui
    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('admin.notify-error', this.notify);
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleMenu_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SimpleMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SimpleMenu_vue__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SimpleMenu: __WEBPACK_IMPORTED_MODULE_0__SimpleMenu_vue___default.a },
  props: {
    items: {
      type: Array,
      default: []
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    header: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: []
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      opened: true,
      autofocus: true,
      msg: false,
      credentials: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    errorLogin: function errorLogin() {
      this.msg = 'Nie mogę Cię zalogować. Twój e-mail lub hasło jest niepoprawne';
    },
    successLogin: function successLogin(res) {
      __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].saveToken(res.data.token);

      __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].my().then(function (res) {
        __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].setUser(res.data.user);
        __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('user.get', res.data.user);
      });

      this.$router.push({
        name: 'admin.home'
      });
    },
    submit: function submit() {
      this.msg = false;
      __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].login(this.credentials).then(this.successLogin, this.errorLogin);
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Auth__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      success: false
    };
  },
  mounted: function mounted() {
    this.doLogout();
  },

  methods: {
    goLogin: function goLogin() {
      this.$router.push({
        name: 'login'
      });
    },
    doLogout: function doLogout() {
      __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].clearToken();
      this.success = true;
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      modal: {
        show: false,
        title: 'Dodaj grupę',
        baseCreateTitle: 'Dodaj grupę',
        baseUpdateTitle: 'Edytuj grupę'
      },
      item: __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].getBaseItem()
    };
  },

  methods: {
    onEmailGroupsChange: function onEmailGroupsChange(e) {
      this.modal.show = false;
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('email-groups.reload', e);
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getItem(id);
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'admin.email-groups.dashboard', params: { id: this.item.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].get(id).then(function (res) {
        var item = __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].convertNulls(res.data.item);
        _this.item = item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Templates__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Accounts__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__["a" /* default */]],
  props: {
    item: {
      type: Object,
      default: __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__["a" /* default */].getBaseItem()
    }
  },
  data: function data() {
    return {
      errors: [],
      title: 'Dodaj grupę',
      action: 'Dodaj grupę',
      statuses: __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__["a" /* default */].statuses(),
      accounts: [],
      keysForSelect: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].keysForSelect(),
      keysForTemplateSelect: {
        label: 'name',
        value: 'code'
      },
      templates_html: [],
      templates_text: [],
      errorMessages: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    if (this.item.id) {
      this.title = 'Aktualizuj grupę';
      this.action = 'Aktualizuj grupę';
    }
    this.getAccounts();
    this.getTemplates();
  },

  methods: {
    resetForm: function resetForm() {
      this.item = __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__["a" /* default */].getBaseItem();
    },
    getAccounts: function getAccounts() {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_6__services_Accounts__["a" /* default */].names().then(function (res) {
        _this.accounts = res.data.items;

        _this.setLoading(false);
      });
    },
    getTemplates: function getTemplates() {
      var _this2 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_4__services_Templates__["a" /* default */].names().then(function (res) {
        _this2.templates_text = [{ code: null, name: 'Domyślny szablon' }].concat(res.data.items.filter(function (item) {
          return item.template_type === 'text';
        }));
        _this2.templates_html = [{ code: null, name: 'Domyślny szablon' }].concat(res.data.items.filter(function (item) {
          return item.template_type === 'html';
        }));
        _this2.setLoading(false);
      });
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy');
    },
    success: function success(res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('email-groups.update', this.item);
          this.notify('Zmieniłeś grupę');
          this.$router.push({
            name: 'admin.email-groups.show',
            params: { id: this.item.id }
          });
        }
      } else {
        if (res.status === 201) {
          this.$emit('email-groups.create', this.item);
          this.notify('Dodałeś grupę');
          this.$router.push({
            name: 'admin.email-groups.show',
            params: { id: res.data.item.id }
          });
        }
      }
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);

      var item = {};
      if (this.item.id) {
        item.id = this.item.id;
      }
      item.name = this.item.name;
      item.status = this.item.status;
      item.email_account_id = this.item.email_account_id;
      item.public = this.item.public;

      item.user_agree = this.item.user_agree;
      item.user_agree_text = this.item.user_agree_text;
      item.user_agree_url = this.item.user_agree_url;
      item.user_agree_label = this.item.user_agree_label;

      item.user_agree2 = this.item.user_agree2;
      item.user_agree2_text = this.item.user_agree2_text;
      item.user_agree2_url = this.item.user_agree2_url;
      item.user_agree2_label = this.item.user_agree2_label;

      item.form_title = this.item.form_title;
      item.form_submit_btn = this.item.form_submit_btn;
      item.form_html_body = this.item.form_html_body;
      item.success_msg = this.item.success_msg;
      item.success_signup_template_html = this.item.success_signup_template_html;
      item.success_signup_template_text = this.item.success_signup_template_text;
      item.confirm_page_template = this.item.confirm_page_template;

      item.confirm_email_body = this.item.confirm_email_body;
      if (this.item.id) {
        __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__["a" /* default */].update(item).then(this.success, this.error);
      } else {
        __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__["a" /* default */].create(item).then(this.success, this.error);
      }
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  methods: {
    getService: function getService() {
      return __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */];
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.reload();
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('email-groups.reload', function () {
      _this3.meta.current_page = 1;
      _this3.reload();
    });
  }
  // events: {
  //   'email-groups.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }

});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      meta: {
        current_page: 1,
        last_page: 0,
        total: 0,
        per_page: 10,
        sort: 'id',
        direction: 'desc',
        limits: [10, 20, 50, 100, 500],
        filter: {}
      },
      emails: [],
      pageUrl: '',
      item: __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].getBaseItem(),
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.pageUrl = __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].signupPagePreviewUrl(this.id);
    this.getItem(this.id);
    this.getEmails(this.meta);
  },

  methods: {
    getEmails: function getEmails(meta) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].inGroup(this.id, meta).then(function (res) {
        _this.emails = res.data.items;
        _this.meta = res.data.meta;
        _this.setLoading(false);
      });
    },
    getItem: function getItem(id) {
      var _this2 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].get(id).then(function (res) {
        var item = __WEBPACK_IMPORTED_MODULE_0__services_EmailGroups__["a" /* default */].convertNulls(res.data.item);
        _this2.item = item;
        _this2.setLoading(false);
      });
    },
    openPreviewFormPage: function openPreviewFormPage() {
      window.open(this.pageUrl);
    },
    changePage: function changePage(page) {
      this.meta.current_page = page;
      this.getEmails(this.meta);
    },
    changeLimit: function changeLimit(limit) {
      this.meta.per_page = limit;
      this.meta.current_page = 1;
      this.getEmails(this.meta);
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Emails__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Emails__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Emails__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Emails__["a" /* default */].getBaseItem()
    };
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Emails__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Emails__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getItem(id);
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'admin.emails.show', params: { id: this.item.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Emails__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item']
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Emails__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__["a" /* default */]],
  data: function data() {
    return {
      separator: ';',
      email_groups: [],
      default_separator: '\t',
      separators: __WEBPACK_IMPORTED_MODULE_5__services_Emails__["a" /* default */].separators(),
      groups: [],
      keysForSelect: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].keysForSelect(),
      errorMessages: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    this.getEmailGroups();
  },

  methods: {
    getEmailGroups: function getEmailGroups() {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_4__services_EmailGroups__["a" /* default */].names().then(function (res) {
        _this.groups = res.data.items;
        _this.setLoading(false);
      });
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy');
    },
    success: function success(res) {
      window.location.href = res.data.url;
      this.notify('Plik został wysłany ');
    },
    submit: function submit() {
      var separator = this.separator;
      var groups = this.email_groups;
      __WEBPACK_IMPORTED_MODULE_5__services_Emails__["a" /* default */].getExportUrl(separator, groups.join(',')).then(this.success, this.error);
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EmailGroups__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      name: '',

      groups_ids: [],
      groups: [],
      groups_default: [],

      status: null,
      status_se: null,
      status_default: null,
      statuses: [{ name: 'Potwierdzone', id: 1 }, { name: 'Niepotwierdzone', id: 0 }, { name: 'Usunięte', id: 2 }],

      keysForSelect: __WEBPACK_IMPORTED_MODULE_0__services_Utils__["a" /* default */].keysForSelect()
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EmailGroups__["a" /* default */].names().then(function (res) {
      _this.groups = res.data.items;
    });
  },

  methods: {
    getFilters: function getFilters() {
      var filters = {
        name: this.name,
        groups_ids: this.groups_ids,
        status: this.status
      };

      return filters;
    },
    filter: function filter() {
      this.$emit('filter', this.getFilters());
    },
    removeFilter: function removeFilter() {
      this.name = '';
      this.groups_ids = [];
      this.status = null;
      this.was_imported = false;
      this.$emit('filter', this.getFilters());
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Emails__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__["a" /* default */]],
  props: ['item'],
  data: function data() {
    return {
      groups: [],
      errors: [],
      statuses: __WEBPACK_IMPORTED_MODULE_4__services_Emails__["a" /* default */].statuses(),
      keysForSelect: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].keysForSelect(),
      errorMessages: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    this.getGroups();
  },

  methods: {
    getGroups: function getGroups() {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_5__services_EmailGroups__["a" /* default */].names().then(function (res) {
        _this.groups = res.data.items;
        _this.setLoading(false);
      });
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy');
    },
    success: function success(res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.notify('Zmieniłeś adres e-mail');
          this.$router.push({
            name: 'admin.emails.show',
            params: {
              id: this.item.id
            }
          });
        }
      } else {
        if (res.status === 201) {
          this.notify('Dodałeś adres e-mail');
          this.$router.push({
            name: 'admin.emails.show',
            params: {
              id: res.data.item.id
            }
          });
        }
      }
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);

      var item = {};
      if (this.item.id) {
        item.id = this.item.id;
      }
      item.email = this.item.email;
      item.groups_ids = this.item.groups_ids;

      if (this.item.id) {
        __WEBPACK_IMPORTED_MODULE_4__services_Emails__["a" /* default */].update(item).then(this.success, this.error);
      } else {
        __WEBPACK_IMPORTED_MODULE_4__services_Emails__["a" /* default */].create(item).then(this.success, this.error);
      }
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_EmailGroups__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Emails__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__["a" /* default */]],
  data: function data() {
    return {
      errors: [],
      item: {
        groups: [],
        emails: ''
      },
      groups: [],
      keysForSelect: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].keysForSelect(),
      errorMessages: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    this.getEmailGroups();
  },

  methods: {
    getEmailGroups: function getEmailGroups() {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_4__services_EmailGroups__["a" /* default */].names().then(function (res) {
        _this.groups = res.data.items;
        _this.setLoading(false);
      });
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notifyError('Wystąpiły błędy');
    },
    success: function success(res) {
      if (res.status === 201) {
        this.notify('Dodałeś ' + res.data.created + ' nowych adresów e-mail. Zmieniłeś grupy dla ' + res.data.changed + ' adresów e-mail');
      }
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);

      var data = {};

      data.emails = this.item.emails.split('\n');
      data.email_groups_ids = this.item.groups;

      __WEBPACK_IMPORTED_MODULE_5__services_Emails__["a" /* default */].import(data).then(this.success, this.error);
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Emails__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  methods: {
    getService: function getService() {
      return __WEBPACK_IMPORTED_MODULE_1__services_Emails__["a" /* default */];
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_Emails__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.reload();
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    },
    filter: function filter(filters) {
      this.meta.filter = filters;
      this.meta.current_page = 1;
      this.reload();
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Emails__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Emails__["a" /* default */].getBaseItem(),
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.getItem(this.id);
  },

  methods: {
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Emails__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    this.reload();
  },

  methods: {
    reload: function reload() {
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('messages.reload');
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getItem(id);
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'admin.messages.dashboard', params: { id: this.item.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Curl__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_Accounts__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Templates__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_EmailGroups__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__["a" /* default */]],
  props: ['item'],
  data: function data() {
    return {
      errors: [],
      title: 'Dodaj wiadomość',
      action: 'Dodaj wiadomość',
      statuses: __WEBPACK_IMPORTED_MODULE_5__services_Messages__["a" /* default */].statuses(),
      accounts: [],
      emailGroups: [],
      templates_text: [],
      templates_html: [],
      keysForSelect: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].keysForSelect(),
      keysForTemplateSelect: {
        label: 'name',
        value: 'code'
      },
      showHelp: false,
      help: '<a href="{{ route(\'email-groups\', {token: token }) }}">Wypisz się z naszego newslettera.</a>.',
      help2: '<a href="{{ route(\'email-group-confirm\', {token: confirm_token }) }}">Potwierdź swój email</a>.',
      modal: {
        show: false,
        title: 'Wybierz url'
      },
      errorMessages: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    if (this.item.id) {
      this.title = 'Aktualizuj wiadomość';
      this.action = 'Aktualizuj wiadomość';
    }
    this.getAccounts();
    this.getGroups();
    this.getTemplates();
  },

  methods: {
    inputC: function inputC(e) {
      this.item.html_body = e;
    },
    resetForm: function resetForm() {
      this.item = __WEBPACK_IMPORTED_MODULE_5__services_Messages__["a" /* default */].getBaseItem();
    },
    toggleHelp: function toggleHelp() {
      this.showHelp = !this.showHelp;
    },
    importUrl: function importUrl() {
      this.$refs.modal1.open();
    },
    getUrl: function getUrl(url) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_4__services_Curl__["a" /* default */].get(url).then(function (res) {
        _this.item.html_body = res.data.html_body;
        _this.item.text_body = res.data.text_body;
        _this.setLoading(false);
      }, function () {
        _this.notify('Nie mogłem pobrać zdalnej zawartości z danego adresu url');
        _this.setLoading(false);
      });

      this.item.import_html_url = url;
      this.$refs.modal1.close();
    },
    getAccounts: function getAccounts() {
      var _this2 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_6__services_Accounts__["a" /* default */].names().then(function (res) {
        _this2.accounts = res.data.items;
        _this2.setLoading(false);
      });
    },
    getGroups: function getGroups() {
      var _this3 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_8__services_EmailGroups__["a" /* default */].names().then(function (res) {
        _this3.emailGroups = res.data.items;
        _this3.setLoading(false);
      });
    },
    getTemplates: function getTemplates() {
      var _this4 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_7__services_Templates__["a" /* default */].names().then(function (res) {
        _this4.templates_text = res.data.items.filter(function (item) {
          return item.template_type === 'text';
        });
        _this4.templates_html = res.data.items.filter(function (item) {
          return item.template_type === 'html';
        });
        _this4.setLoading(false);
      });
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy');
    },
    success: function success(res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.notify('Zmieniłeś wiadomość');
          this.$router.push({
            name: 'admin.messages.show',
            params: {
              id: this.item.id
            }
          });
        }
      } else {
        if (res.status === 201) {
          this.notify('Dodałeś wiadomość');
          this.$router.push({
            name: 'admin.messages.show',
            params: {
              id: res.data.item.id
            }
          });
        }
      }
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);

      var item = {};
      if (this.item.id) {
        item.id = this.item.id;
      }
      item.title = this.item.title;
      item.text_body = this.item.text_body;
      item.html_body = this.item.html_body;
      item.email_account_id = this.item.email_account_id;
      item.use_template = this.item.use_template;
      item.template_html = this.item.template_html;
      item.template_text = this.item.template_text;

      item.status = this.item.status;
      item.email_groups_ids = this.item.email_groups_ids;

      item.send_to_all = this.item.send_to_all;
      item.send_to_confirmed = this.item.send_to_confirmed;
      item.send_to_notconfirmed = this.item.send_to_notconfirmed;
      item.send_to_imported = this.item.send_to_imported;
      item.send_to_signout = this.item.send_to_signout;

      if (this.item.id) {
        __WEBPACK_IMPORTED_MODULE_5__services_Messages__["a" /* default */].update(item).then(this.success, this.error);
      } else {
        __WEBPACK_IMPORTED_MODULE_5__services_Messages__["a" /* default */].create(item).then(this.success, this.error);
      }
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  methods: {
    getService: function getService() {
      return __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */];
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.reload();
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('messages.reload', function () {
      _this3.meta.current_page = 1;
      _this3.reload();
    });
  }
  // ,
  // events: {
  //   'messages.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }

});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['status']
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  props: ['id'],
  data: function data() {
    return {
      stats: {
        total: 0,
        failure: 0,
        success: 0
      }
    };
  },

  methods: {
    paginate: function paginate(meta) {
      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].paginateSendLog(this.id, meta).then(this.success);
    },
    success: function success(res) {
      this.items = res.data.items;
      this.stats = res.data.stats;
      var filter = this.meta.filter;
      this.meta = res.data.meta;
      this.meta.filter = filter;
      this.setLoading(false);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('messages.send-log.reload', function () {
      _this.meta.current_page = 1;
      _this.reload();
    });
  }
  // events: {
  //   'messages.send-log.reload': function () {
  //     this.reload()
  //   }
  // }

});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['item'],
  computed: {
    msgs: function msgs() {
      var a = [];
      if (this.item.send_to_all) {
        a.push('Do wszystkich');
      } else {
        if (this.item.send_to_confirmed) {
          a.push('Do potwierdzonych');
        }
        if (this.item.send_to_notconfirmed) {
          a.push('Do niepotwierdzonych');
        }
        if (this.item.send_to_imported) {
          a.push('Do zaimportowanych');
        }
        if (this.item.send_to_signout) {
          a.push('Do wypisanych');
        }
      }
      return a;
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__["a" /* default */]],
  props: ['id'],
  methods: {
    paginate: function paginate(meta) {
      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].paginateSendTo(this.id, meta).then(this.successPaginate, this.errorPaginate);
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].getBaseItem(),
      toSendTotal: 0,
      modal: {
        baseTitle: 'Subkskrybenci',
        title: '',
        show: false
      },
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.getItem(this.id);
    this.getToSendInfo(this.id);
  },

  methods: {
    showSubscribers: function showSubscribers() {
      this.$refs.modal1.open();
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.$router.push({ name: 'admin.messages.dashboard' });
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    },
    getItem: function getItem(id) {
      var _this3 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].get(id).then(function (res) {
        _this3.item = res.data.item;
        _this3.setLoading(false);
      });
    },
    getToSendInfo: function getToSendInfo(id) {
      var _this4 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].toSendTotal(id).then(function (res) {
        _this4.toSendTotal = res.data.total;
        _this4.modal.title = _this4.modal.baseTitle + ' (' + res.data.total + ')';
        _this4.setLoading(false);
      });
    },
    preview: function preview(id, what) {
      var _this5 = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Messages__["a" /* default */].preview(id, what).then(function (res) {
        var out = res.data.preview;
        _this5.setLoading(false);
        var win = window.open();
        if (win) {
          win.document.write(out);
        } else {
          _this5.notify('Nie mogę otworzyć nowego okna przeglądarki, pozwól na otwieranie okien przeglądarki.');
        }
      });
    },
    reload: function reload() {
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('messages.send-log.reload');
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Messages__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_FormErrors__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_FormErrors__["a" /* default */]],
  props: ['item'],
  data: function data() {
    return {
      errors: [],
      send_to: '',
      errorMessages: __WEBPACK_IMPORTED_MODULE_0__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {},

  methods: {
    error: function error(err) {
      this.errors = this.getResponseErrors(err);
      this.notify('Wystąpiły błędy przy wysłaniu wiadomości, sprawdź dane do konta smtp');
    },
    success: function success() {
      this.notify('Wysłano poprawnie tą wiadomość na podany adres e-mail');
    },
    submit: function submit() {
      this.errors = [];
      window.scrollTo(0, 0);
      var data = {
        send_to: this.send_to
      };
      __WEBPACK_IMPORTED_MODULE_1__services_Messages__["a" /* default */].test(this.item.id, data).then(this.success, this.error);
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_FormErrors__["a" /* default */]],
  data: function data() {
    return {
      error: [],
      errorMessages: __WEBPACK_IMPORTED_MODULE_1__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email']),
      url: '',
      iframeUrl: null
    };
  },

  methods: {
    submit: function submit() {
      this.$emit('choose', this.url);
    },
    changed: function changed() {
      this.iframeUrl = this.url;
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Utils__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_FormErrors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      form: {
        password: '',
        password2: ''
      },
      errorMessages: __WEBPACK_IMPORTED_MODULE_4__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'max'])
    };
  },

  methods: {
    success: function success() {
      this.notify('Zmieniłeś swoje hasło');
      this.setLoading(false);
      this.$router.push({
        name: 'admin.my'
      });
    },
    error: function error(err) {
      console.log(err);
      var errors = this.getResponseErrors(err);
      console.log(errors);
      this.notify('Nie mogłem zmienić hasła. Upewnij się że wpisane hasła są takie same i mają odpowiednia długość');
      this.setLoading(false);
    },
    submit: function submit() {
      this.msg = false;
      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_2__services_Auth__["a" /* default */].changePassword(this.form).then(this.success, this.error);
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Auth__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {
        email: null
      }
    };
  },

  methods: {
    href: function href(email) {
      return 'mailto: ' + email;
    },
    success: function success(res) {
      this.user = res.data.user;
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('admin.loading', false);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('admin.loading', true);
    __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].my().then(this.success);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    meta: {
      type: Object,
      default: function _default() {
        return {
          current_page: 1,
          last_page: 0,
          total: 0,
          per_page: 10,
          limits: []
        };
      }
    }
  },
  data: function data() {
    return {
      iconRight: true
    };
  },
  mounted: function mounted() {},

  methods: {
    setLimit: function setLimit(e) {
      this.$emit('pagination-limit', e.currentTarget.value);
    },
    setPage: function setPage(page) {
      this.$emit('pagination-page', page);
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['sort', 'keyFor', 'direction'],
  methods: {
    changeOrder: function changeOrder(sort, dir) {
      this.$emit('change-order', sort, dir);
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Templates__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Templates__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      modal: {
        show: false,
        title: 'Dodaj szablon',
        baseCreateTitle: 'Dodaj szablon',
        baseUpdateTitle: 'Edytuj szablon'
      },
      item: __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].getBaseItem()
    };
  },

  methods: {
    onTemplatesChange: function onTemplatesChange(e) {
      this.modal.show = false;
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('templates.reload', e);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('templates.show-edit', function (item) {
      _this.item = item;
      _this.showUpdateForm();
    });
  }
  // events: {
  //   'templates.show-edit': function (item) {
  //     this.item = item
  //     this.showUpdateForm()
  //   }
  // }

});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Templates__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getItem(id);
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'admin.templates.dashboard', params: { id: this.item.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Templates__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__["a" /* default */]],
  props: ['item'],
  data: function data() {
    return {
      autofocus: true,
      title: 'Dodaj szablon',
      action: 'Dodaj szablon',
      templateTypes: __WEBPACK_IMPORTED_MODULE_3__services_Templates__["a" /* default */].templateTypes(),
      errorMessages: __WEBPACK_IMPORTED_MODULE_2__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric'])
    };
  },
  mounted: function mounted() {
    if (this.item.id) {
      this.title = 'Aktualizuj szablon';
      this.action = 'Aktualizuj szablon';
    }
  },

  methods: {
    resetForm: function resetForm() {
      this.item = __WEBPACK_IMPORTED_MODULE_3__services_Templates__["a" /* default */].getBaseItem();
    },
    error: function error() {
      this.notify('Nie mogę zapisać. Sprawdź czy wpisałeś nazwę');
    },
    success: function success(res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('templates.update', this.item);
          this.notify('Zmieniłeś szablon');
          this.$router.push({ name: 'admin.templates.show', params: { id: this.item.id } });
        }
      } else {
        if (res.status === 201) {
          this.$emit('templates.create', this.item);
          this.notify('Dodałeś szablon');
          this.$router.push({ name: 'admin.templates.show', params: { id: res.data.item.id } });
        }
      }
    },
    submit: function submit() {
      var item = {};
      if (this.item.id) {
        item.id = this.item.id;
      }
      item.name = this.item.name;
      item.status = this.item.status;
      item.body = this.item.body;
      item.template_type = this.item.template_type;

      if (this.item.id) {
        __WEBPACK_IMPORTED_MODULE_3__services_Templates__["a" /* default */].update(item).then(this.success, this.error);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__services_Templates__["a" /* default */].create(item).then(this.success, this.error);
      }
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Templates__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      disabled: true,
      showConfirm: false
    };
  },

  methods: {
    getService: function getService() {
      return __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */];
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.reload();
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('templates.reload', function () {
      _this3.meta.current_page = 1;
      _this3.reload();
    });
  }
  // events: {
  //   'templates.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }

});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Templates__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].getBaseItem(),
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;

    this.getItem(this.id);
  },

  methods: {
    edit: function edit() {
      this.$router.push({ name: 'admin.templates.edit', params: { id: this.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Templates__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Users__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Users__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      modal: {
        show: false,
        title: 'Dodaj administratora',
        baseCreateTitle: 'Dodaj administratora',
        baseUpdateTitle: 'Edytuj administratora'
      },
      item: __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].getBaseItem()
    };
  },

  methods: {
    onUsersChange: function onUsersChange(e) {
      this.modal.show = false;
      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('users.reload', e);
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Users__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].getBaseItem()
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getItem(id);
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'admin.users.dashboard', params: { id: this.item.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_Users__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_Notify__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_FormErrors__["a" /* default */]],
  props: {
    item: {
      type: Object, default: __WEBPACK_IMPORTED_MODULE_4__services_Users__["a" /* default */].getBaseItem()
    }
  },
  data: function data() {
    return {
      autofocus: true,
      errors: [],
      title: 'Dodaj administratora',
      action: 'Dodaj administratora',
      errorMessages: __WEBPACK_IMPORTED_MODULE_3__services_Utils__["a" /* default */].errorMessages(['required', 'min', 'numeric', 'email'])
    };
  },
  mounted: function mounted() {
    if (this.item.id) {
      this.title = 'Aktualizuj administratora';
      this.action = 'Aktualizuj administratora';
    }
  },

  methods: {
    resetForm: function resetForm() {
      this.item = __WEBPACK_IMPORTED_MODULE_4__services_Users__["a" /* default */].getBaseItem();
    },
    error: function error(err) {
      this.errors = this.getResponseErrors(err);

      this.notify('Wystąpiły błędy, sprawdź poprawność wpisanych danych');
    },
    success: function success(res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('users.update', this.item);
          this.notify('Zmieniłeś administratora');
          this.$router.push({ name: 'admin.users.show', params: { id: this.item.id } });
        }
      } else {
        if (res.status === 201) {
          this.$emit('users.create', this.item);
          this.notify('Dodałeś administratora');
          this.$router.push({ name: 'admin.users.show', params: { id: res.data.item.id } });
        }
      }
    },
    submit: function submit() {
      var item = {};
      item.first_name = this.item.first_name;
      item.last_name = this.item.last_name;
      item.email = this.item.email;
      item.status = this.item.status;

      if (this.item.id) {
        item.id = this.item.id;
      } else {
        item.password = this.item.password;
        item.password2 = this.item.password2;
      }

      if (this.item.id) {
        __WEBPACK_IMPORTED_MODULE_4__services_Users__["a" /* default */].update(item).then(this.success, this.error);
      } else {
        __WEBPACK_IMPORTED_MODULE_4__services_Users__["a" /* default */].create(item).then(this.success, this.error);
      }
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Users__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_Paginate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_Notify__["a" /* default */]],
  methods: {
    getService: function getService() {
      return __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */];
    },
    _remove: function _remove(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].remove(item.id).then(function (res) {
        if (res.status === 204) {
          _this.reload();
          _this.notify('Usunięto');
        }
      });
    },
    remove: function remove(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$emit('confirm.show', {
        confirmCb: function confirmCb() {
          _this2._remove(item);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__services_EventEmitter__["a" /* default */].$on('users.reload', function () {
      _this3.meta.current_page = 1;
      _this3.reload();
    });
  }
  // events: {
  //   'users.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }

});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Users__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Loading__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Loading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_Notify__["a" /* default */]],
  data: function data() {
    return {
      item: __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].getBaseItem(),
      id: null
    };
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.getItem(this.id);
  },

  methods: {
    edit: function edit() {
      this.$router.push({ name: 'admin.users.edit', params: { id: this.id } });
    },
    getItem: function getItem(id) {
      var _this = this;

      this.setLoading(true);
      __WEBPACK_IMPORTED_MODULE_0__services_Users__["a" /* default */].get(id).then(function (res) {
        _this.item = res.data.item;
        _this.setLoading(false);
      });
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Utils__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String,
      default: 'unknownName'
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    keys: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0__services_Utils__["a" /* default */].keysForSelect();
      }
    }
  },
  data: function data() {
    return {
      model: this.getBaseModel()
    };
  },

  methods: {
    getBaseModel: function getBaseModel() {
      return [];
    },
    onInput: function onInput(e) {
      var _this = this;

      var ids = e.map(function (el) {
        return el[_this.keys.value];
      });
      this.selectValue(ids);
    },
    selectValue: function selectValue(ids) {
      var foundObj = this.changeValue(ids);

      if (!foundObj.found) {
        this.clearModel();
      } else {
        this.emitValue(foundObj.value);
      }
    },
    emitValue: function emitValue(value) {
      this.$emit('input', value);
    },
    changeValue: function changeValue(ids) {
      var _this2 = this;

      var found = false;
      var value = null;

      var foundIds = [];
      var model = [];
      var isIn = false;
      // znajdz te id ktore sa w ids
      if (ids) {
        this.options.map(function (el, i) {
          isIn = _this2.isIn(ids, el[_this2.keys.value]);
          if (isIn) {
            model.push(_this2.options[i]);
            foundIds.push(el[_this2.keys.value]);
          }
        });
        if (foundIds.length) {
          found = true;
          value = foundIds;
          this.model = model;
        }
      }

      return { found: found, value: value };
    },
    isIn: function isIn(ids, id) {
      return ids.filter(function (el, i) {
        return el === id;
      }).length > 0;
    },
    clearModel: function clearModel() {
      this.model = [];
    }
  },
  watch: {
    options: function options(n, o) {
      this.selectValue(this.value);
    }
  },
  mounted: function mounted() {
    this.selectValue(this.value);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Utils__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: [String, Number, Array],
      default: -1
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: {
      type: String,
      default: 'unknownName'
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    keys: {
      type: Object,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__services_Utils__["a" /* default */].keysForSelect();
      }
    }
  },
  data: function data() {
    return {
      model: this.getBaseModel()
    };
  },

  methods: {
    getBaseModel: function getBaseModel() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.keys.value, null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.keys.label, ''), _ref;
    },
    onInput: function onInput(e) {
      this.selectValue(e[this.keys.value]);
    },
    selectValue: function selectValue(id) {
      var foundObj = this.changeValue(id);

      if (!foundObj.found) {
        this.clearModel();
      } else {
        this.emitValue(foundObj.value);
      }
    },
    emitValue: function emitValue(value) {
      this.$emit('input', value);
    },
    changeValue: function changeValue(id) {
      var _this = this;

      var found = false;
      var value = null;

      this.options.map(function (el, i) {
        if (el[_this.keys.value] === id) {
          _this.model = _this.options[i];
          found = true;
          value = id;
        }
      });

      return { found: found, value: value };
    },
    clearModel: function clearModel() {
      var _model;

      this.model = (_model = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_model, this.keys.value, null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_model, this.keys.label, ''), _model);
    }
  },
  watch: {
    value: function value(n, o) {
      if (n !== o) {
        this.selectValue(n);
      }
    },
    options: function options(n, o) {
      this.selectValue(this.value);
    }
  },
  mounted: function mounted() {
    this.selectValue(this.value);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: true
    };
  },

  methods: {
    tooglePanel: function tooglePanel() {
      if (!this.collapsible) {
        return;
      }
      this.show = !this.show;
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tree',
  props: {
    model: Object,
    selected: Object
  },
  data: function data() {
    return {
      open: true
    };
  },
  computed: {
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
    isSelected: function isSelected(model) {
      if (!model || !this.selected || model.isRoot) {
        return false;
      }
      return this.selected.id === model.id ? 'active' : '';
    },
    changeType: function changeType() {
      if (!this.isFolder) {
        // TODO sprawdzić czy to będzie działać Vue.set(this.model, 'children', [])
        this.addChild();
        this.open = true;
      }
    },
    selectItem: function selectItem(model) {
      if (model.id) {
        this.$dispatch('tree.selected', model);
      }
    },
    addChild: function addChild() {
      this.model.children.push({
        name: 'new stuff'
      });
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['selected'],
  methods: {
    clearSelected: function clearSelected() {
      this.$dispatch('tree-clear-selected');
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String
    },
    id: {
      type: String,
      default: 'editor'
    },
    height: {
      type: String,
      default: '200px'
    },
    fullpage: {
      type: Boolean,
      default: true
    },
    allowedContent: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Array,
      default: function _default() {
        return [{
          name: 'document',
          groups: ['mode', 'document', 'doctools']
        }, {
          name: 'clipboard',
          groups: ['clipboard', 'undo']
        }, {
          name: 'editing',
          groups: ['find', 'selection', 'spellchecker', 'editing']
        }, {
          name: 'forms',
          groups: ['forms']
        }, '/', {
          name: 'basicstyles',
          groups: ['basicstyles', 'cleanup']
        }, {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']
        }, {
          name: 'links',
          groups: ['links']
        }, {
          name: 'insert',
          groups: ['insert']
        }, '/', {
          name: 'styles',
          groups: ['styles']
        }, {
          name: 'colors',
          groups: ['colors']
        }, {
          name: 'tools',
          groups: ['tools']
        }, {
          name: 'others',
          groups: ['others']
        }, {
          name: 'about',
          groups: ['about']
        }];
      }
    },
    language: {
      type: String,
      default: 'pl'
    },
    extraplugins: {
      type: String,
      default: ''
    }
  },
  beforeUpdate: function beforeUpdate() {
    var ckeditorId = this.id;

    if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
      CKEDITOR.instances[ckeditorId].setData(this.value);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var ckeditorId = this.id;
    var ckeditorConfig = {
      toolbarGroups: this.toolbar,
      fullPage: this.fullpage,
      allowedContent: this.allowedContent,
      language: this.language,
      height: this.height,
      extraPlugins: this.extraplugins
    };

    CKEDITOR.replace(ckeditorId, ckeditorConfig);

    CKEDITOR.instances[ckeditorId].setData(this.value);
    CKEDITOR.instances[ckeditorId].on('change', function () {
      var ckeditorData = CKEDITOR.instances[ckeditorId].getData();
      if (ckeditorData !== _this.value) {
        _this.$emit('input', ckeditorData);
      }
    });
  },
  destroyed: function destroyed() {
    var ckeditorId = this.id;

    if (CKEDITOR.instances[ckeditorId]) {
      CKEDITOR.instances[ckeditorId].destroy();
    }
  }
});

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(256),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(272),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(250),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(226),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(286),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(251),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(254),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(287),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(257),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(230),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(235),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(253),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(241),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(274),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(275),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(278),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(224),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(229),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(292),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(247),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(289),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(232),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(262),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(281),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(227),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(265),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(268),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(271),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(280),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(283),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(239),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(277),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(223),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(245),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(284),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(244),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(290),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(259),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(269),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(238),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(266),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.email) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(adres e-mail)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.show',
          params: {
            id: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('emails-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Administratorzy\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.users.create'
        })
      }
    }
  }, [_vm._v("Dodaj administratora")])], 1), _vm._v(" "), _c('users-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        Import wielu adresów e-mail\n    ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")])], 1), _vm._v(" "), _c('ui-alert', {
    attrs: {
      "dismissible": false,
      "hide-icon": ""
    }
  }, [_vm._v("\n        Wklej adresy e-mail w pole poniżej, jeden adres w jednej lini. Adresy zostaną sprawdzone i zostaną dodane tylko te które jeszcze nie istnieją. Jeśli adres e-mail istnieje jego grupy zostaną zmienione na wybrane ponizej.\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Wklej adresy e-mail",
      "name": "emails",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wklej adresy e-mail",
      "multi-line": "",
      "rows": 8
    },
    model: {
      value: (_vm.item.emails),
      callback: function($$v) {
        _vm.item.emails = $$v
      },
      expression: "item.emails"
    }
  }), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "groups",
      "label": "Grupy do których będą dodane te adresy",
      "keys": _vm.keysForSelect,
      "options": _vm.groups,
      "search-placeholder": "Szukaj",
      "show-search": true,
      "placeholder": "wybierz grupy do których będą dodane te adresy",
      "required": ""
    },
    model: {
      value: (_vm.item.groups),
      callback: function($$v) {
        _vm.item.groups = $$v
      },
      expression: "item.groups"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Importuj wklejone adresy")])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "short-page"
  }, [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.msg) + "\n        ")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goLogin($event)
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(konto do wysyłania)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.show',
          params: {
            id: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj konto")])], 1), _vm._v(" "), (_vm.item) ? _c('accounts-test-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                E-mail\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'email',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Status\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Zaimportowany\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'was_imported',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.email) + "\n            ")]), _vm._v(" "), _c('td', [(item) ? _c('email-status', {
      attrs: {
        "item": item
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.was_imported) ? _c('p', [_vm._v("\n                    Tak. " + _vm._s(item.imported_at_formated) + "\n                ")]) : _vm._e(), _vm._v(" "), (!item.was_imported) ? _c('p', [_vm._v("\n                    Nie\n                ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Podstawowe dane")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoja nazwa grupy",
      "name": "name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.item.name = $$v
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "account",
      "label": "Konto do wysłania wiadomości przy zapisywaniu się do tej grupy",
      "options": _vm.accounts,
      "placeholder": "Wybierz konto",
      "required": ""
    },
    model: {
      value: (_vm.item.email_account_id),
      callback: function($$v) {
        _vm.item.email_account_id = $$v
      },
      expression: "item.email_account_id"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "status",
      "label": "Status",
      "options": _vm.statuses,
      "placeholder": "Wybierz status",
      "required": ""
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.item.status = $$v
      },
      expression: "item.status"
    }
  }), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "public"
    },
    model: {
      value: (_vm.item.public),
      callback: function($$v) {
        _vm.item.public = $$v
      },
      expression: "item.public"
    }
  }, [_vm._v("Grupa publiczna")])], 1), _vm._v(" "), (_vm.item.public) ? _c('fieldset', [_c('legend', [_vm._v("Formularz zapisywania się")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tytuł",
      "name": "form_title",
      "type": "text",
      "placeholder": "Wpisz tytuł formularza"
    },
    model: {
      value: (_vm.item.form_title),
      callback: function($$v) {
        _vm.item.form_title = $$v
      },
      expression: "item.form_title"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst przycisku",
      "name": "form_submit_btn",
      "type": "text",
      "placeholder": "Wpisz tekst przycisku"
    },
    model: {
      value: (_vm.item.form_submit_btn),
      callback: function($$v) {
        _vm.item.form_submit_btn = $$v
      },
      expression: "item.form_submit_btn"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Dodatkowa treść nad formularzem",
      "name": "form_html_body",
      "type": "text",
      "multi-line": true,
      "rows": 4,
      "placeholder": "Wpisz dodatkową treść"
    },
    model: {
      value: (_vm.item.form_html_body),
      callback: function($$v) {
        _vm.item.form_html_body = $$v
      },
      expression: "item.form_html_body"
    }
  }), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "user_agree"
    },
    model: {
      value: (_vm.item.user_agree),
      callback: function($$v) {
        _vm.item.user_agree = $$v
      },
      expression: "item.user_agree"
    }
  }, [_vm._v("Wymagana zgoda (1)")]), _vm._v(" "), (_vm.item.user_agree) ? _c('div', [_c('ui-textbox', {
    attrs: {
      "label": "Tekst zgody (1)",
      "name": "user_agree_text",
      "type": "text",
      "placeholder": "Wpisz tekst zgody",
      "multi-line": true,
      "rows": 2
    },
    model: {
      value: (_vm.item.user_agree_text),
      callback: function($$v) {
        _vm.item.user_agree_text = $$v
      },
      expression: "item.user_agree_text"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Link z dodatkowymi informacjami (1)",
      "name": "user_agree_url",
      "type": "text",
      "placeholder": "Link z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree_url),
      callback: function($$v) {
        _vm.item.user_agree_url = $$v
      },
      expression: "item.user_agree_url"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst linku z dodatkowymi informacjami (1)",
      "name": "user_agree_label",
      "type": "text",
      "placeholder": "Tekst linku z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree_label),
      callback: function($$v) {
        _vm.item.user_agree_label = $$v
      },
      expression: "item.user_agree_label"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "user_agree2"
    },
    model: {
      value: (_vm.item.user_agree2),
      callback: function($$v) {
        _vm.item.user_agree2 = $$v
      },
      expression: "item.user_agree2"
    }
  }, [_vm._v("Wymagana zgoda (2)")]), _vm._v(" "), (_vm.item.user_agree2) ? _c('div', [_c('ui-textbox', {
    attrs: {
      "label": "Tekst zgody (2)",
      "name": "user_agree2_text",
      "type": "text",
      "placeholder": "Wpisz tekst zgody",
      "multi-line": true,
      "rows": 2
    },
    model: {
      value: (_vm.item.user_agree2_text),
      callback: function($$v) {
        _vm.item.user_agree2_text = $$v
      },
      expression: "item.user_agree2_text"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Link z dodatkowymi informacjami (2)",
      "name": "user_agree2_url",
      "type": "text",
      "placeholder": "Link z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree2_url),
      callback: function($$v) {
        _vm.item.user_agree2_url = $$v
      },
      expression: "item.user_agree2_url"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst linku z dodatkowymi informacjami (2)",
      "name": "user_agree2_label",
      "type": "text",
      "placeholder": "Tekst linku z dodatkowymi informacjami"
    },
    model: {
      value: (_vm.item.user_agree2_label),
      callback: function($$v) {
        _vm.item.user_agree2_label = $$v
      },
      expression: "item.user_agree2_label"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tekst komunikatu po poprawnym zapisaniu się",
      "name": "success_msg",
      "type": "text",
      "placeholder": "Tekst komunikatu po poprawnym zapisaniu się"
    },
    model: {
      value: (_vm.item.success_msg),
      callback: function($$v) {
        _vm.item.success_msg = $$v
      },
      expression: "item.success_msg"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("E-mail z linkiem potwierdzającym")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "success_signup_template_text",
      "label": "Szablon tekstowy",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_text,
      "placeholder": "Wybierz szablon"
    },
    model: {
      value: (_vm.item.success_signup_template_text),
      callback: function($$v) {
        _vm.item.success_signup_template_text = $$v
      },
      expression: "item.success_signup_template_text"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "success_signup_template_html",
      "label": "Szablon html",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_html,
      "placeholder": "Wybierz szablon"
    },
    model: {
      value: (_vm.item.success_signup_template_html),
      callback: function($$v) {
        _vm.item.success_signup_template_html = $$v
      },
      expression: "item.success_signup_template_html"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Dodatkowa treść",
      "name": "confirm_email_body",
      "type": "text",
      "placeholder": "Wpisz dodatkową treść",
      "multi-line": true,
      "rows": 2
    },
    model: {
      value: (_vm.item.confirm_email_body),
      callback: function($$v) {
        _vm.item.confirm_email_body = $$v
      },
      expression: "item.confirm_email_body"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Strona potwierdzenia adresu e-mail")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "confirm_page_template",
      "label": "Szablon html",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_html,
      "placeholder": "Wybierz szablon"
    },
    model: {
      value: (_vm.item.confirm_page_template),
      callback: function($$v) {
        _vm.item.confirm_page_template = $$v
      },
      expression: "item.confirm_page_template"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('email-filters', {
    on: {
      "filter": _vm.filter
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                E-mail\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'email',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n              Status\n              "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Zaimportowany\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'was_imported',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Akcje\n            ")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.emails.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.email))])]), _vm._v(" "), _c('td', [(item) ? _c('email-status', {
      attrs: {
        "item": item
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.was_imported) ? _c('div', [_c('span', {
      staticClass: "label-black"
    }, [_vm._v("Tak.")]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.imported_at_formated))])]) : _vm._e(), _vm._v(" "), (!item.was_imported) ? _c('div', [_c('span', {
      staticClass: "label"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.emails.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dodaj grupę\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do grup")])], 1), _vm._v(" "), _c('email-groups-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(this.status == 1) ? _c('span', {
    staticClass: "badge badge-gray"
  }, [_vm._v("Szkic")]) : _vm._e(), _vm._v(" "), (this.status == 2) ? _c('span', {
    staticClass: "badge badge-alert"
  }, [_vm._v("Przeznaczona do wysłania")]) : _vm._e(), _vm._v(" "), (this.status == 3) ? _c('span', {
    staticClass: "badge badge-alert"
  }, [_vm._v("W trakcie wysyłania")]) : _vm._e(), _vm._v(" "), (this.status == 4) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v("Wysłana")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui-toolbar', {
    attrs: {
      "type": "colored",
      "text-color": "white",
      "loading": _vm.loading,
      "preloader-top": _vm.preloaderTop,
      "remove-nav-icon": _vm.hideNavIcon,
      "flat": true,
      "show-brand": _vm.showBrand
    },
    on: {
      "nav-icon-click": _vm.navIconClick
    }
  }, [_c('div', {
    slot: "brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.home'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    slot: "actions"
  }, [_c('div', {
    staticClass: "toolbar-menu"
  }, [_c('ui-button', {
    attrs: {
      "type": "clear"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.dashboard'
        })
      }
    }
  }, [_vm._v("Wiadomości")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "clear"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Subskrybenci")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-full grid-pad"
  }, [(_vm.menuLeft) ? _c('div', {
    staticClass: "col-2-12"
  }, [_c('left-menu', {
    attrs: {
      "items": _vm.leftMenuItems
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: [
      _vm.menuLeft ? 'col-10-12' : 'col-1-1'
    ]
  }, [_c('div', {
    staticClass: "admin-content"
  }, [_c('router-view'), _vm._v(" "), _c('ui-confirm', {
    ref: "confirm1",
    attrs: {
      "type": "primary",
      "confirm-button-text": _vm.confirm.confirmButton,
      "deny-button-text": _vm.confirm.denyButton,
      "autofocus": "confirm-button",
      "close-on-confirm": true,
      "backdrop-dismissible": true,
      "title": _vm.confirm.confirm
    },
    on: {
      "confirm": _vm.confirmed,
      "deny": _vm.denied
    }
  }, [_vm._v("\n          " + _vm._s(_vm.confirm.message) + "\n        ")])], 1)])]), _vm._v(" "), _c('ui-snackbar-container', {
    ref: "snackbarContainer",
    attrs: {
      "position": _vm.position,
      "allow-html": _vm.allowHtml,
      "queue-snackbars": _vm.queueSnackbars
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sorting"
  }, [_c('ui-button', {
    staticClass: "sort-btn",
    attrs: {
      "disabled": _vm.keyFor == _vm.sort && _vm.direction == 'desc',
      "icon": "keyboard_arrow_down"
    },
    on: {
      "click": function($event) {
        _vm.changeOrder(_vm.keyFor, 'desc')
      }
    }
  }), _vm._v(" "), _c('ui-button', {
    staticClass: "sort-btn",
    attrs: {
      "disabled": _vm.keyFor == _vm.sort && _vm.direction == 'asc',
      "icon": "keyboard_arrow_up"
    },
    on: {
      "click": function($event) {
        _vm.changeOrder(_vm.keyFor, 'asc')
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(grupa)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.edit',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_vm._v("Edytuj grupę")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Grupa publiczna?\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.public ? 'Tak' : 'Nie'))])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Ilość subskrybentów\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.total_emails))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Status\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.status == 1 ? 'Aktywna' : 'Nie aktywna') + "\n              ")])]), _vm._v(" "), (_vm.item.id) ? _c('tr', [_c('th', [_vm._v("\n                  Konto\n              ")]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.show',
          params: {
            id: _vm.item.email_account.id
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.item.email_account.name))])])]) : _vm._e()])]), _vm._v(" "), (_vm.item.id && _vm.item.public) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Kod formularza do zapisywania się do tej grupy\n      ")]), _vm._v(" "), _c('p', [_vm._v("Element do umieszczenie w kodzie html strony tam gdzie chcemy aby pokazał się formularz")]), _vm._v(" "), _c('p', {
    staticClass: "template-pre"
  }, [_vm._v("\n          " + _vm._s(_vm.item.signup_form) + "\n      ")]), _vm._v(" "), _c('p', [_vm._v("Element do umieszczenie w kodzie html strony na samym dole przed końcem znacznika body")]), _vm._v(" "), _c('p', {
    staticClass: "template-pre"
  }, [_vm._v("\n          " + _vm._s(_vm.item.signup_script) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.item.id && _vm.item.public) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Dane formularza do zapisywania się do tej grupy\n      ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "type": "flat"
    },
    on: {
      "click": _vm.openPreviewFormPage
    }
  }, [_vm._v("Podgląd formularza")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Tytuł formularza\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.form_title ? _vm.item.form_title : '—'))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Wymagana zgoda (1)\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.user_agree ? 'Tak' : 'Nie'))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Wymagana zgoda (2)\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.user_agree2 ? 'Tak' : 'Nie'))])])])])]) : _vm._e(), _vm._v(" "), (_vm.item.id && _vm.item.public) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Wiadomość e-mail z linkiem potwierdzającym\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Dodatkowa treść\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.item.confirm_email_body ? _vm.item.confirm_email_body : '—'))])])])])]) : _vm._e(), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Adresy e-mail w tej grupie "), (_vm.meta.total) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("(" + _vm._s(_vm.meta.total) + ")")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      E-mail\n                  ")]), _vm._v(" "), _c('th', [_vm._v("\n                      Status\n                  ")]), _vm._v(" "), _c('th', [_vm._v("\n                      Zaimportowany\n                  ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.emails), function(email) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.emails.show',
            params: {
              id: email.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(email.email))])]), _vm._v(" "), _c('td', [(email) ? _c('email-status', {
      attrs: {
        "item": email
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(email.was_imported) ? _c('p', [_vm._v("\n                          Tak. " + _vm._s(email.imported_at_formated) + "\n                      ")]) : _vm._e(), _vm._v(" "), (!email.was_imported) ? _c('p', [_vm._v("\n                          Nie\n                      ")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Twój profil")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "type": "flat"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.change-password'
        })
      }
    }
  }, [_vm._v("Zmień hasło")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary",
      "type": "flat"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'logout'
        })
      }
    }
  }, [_vm._v("Wyloguj się")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n        Imię i nazwisko\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n        E-mail\n      ")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": _vm.href(_vm.user.email)
    }
  }, [_vm._v(_vm._s(_vm.user.email))])])])])])
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adresat")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail adresata",
      "name": "send_to",
      "type": "text",
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz e-mail adresata wiadomości"
    },
    model: {
      value: (_vm.send_to),
      callback: function($$v) {
        _vm.send_to = $$v
      },
      expression: "send_to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.send_to
    }
  }, [_vm._v("Wyślij testową wiadomość")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    class: {
      bold: _vm.isFolder, root: !_vm.model.id
    }
  }, [_c('a', {
    class: {
      name: true, active: _vm.isSelected(_vm.model)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectItem(_vm.model)
      }
    }
  }, [_vm._v(_vm._s(_vm.model.name))]), _vm._v(" "), (_vm.isFolder) ? _c('span', {
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.open) ? _c('a', {
    staticClass: "open-link"
  }, [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), (!_vm.open) ? _c('a', {
    staticClass: "open-link"
  }, [_vm._v(" + ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, _vm._l((_vm.model.children), function(model, index) {
    return _c('tree', {
      key: index,
      staticClass: "item",
      attrs: {
        "model": model,
        "selected": _vm.selected
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(szablon)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.templates.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do szablonów")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj szablon")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                  Kod szablonu\n              ")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.item.code))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Typ szablonu\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.template_type == 'html' ? 'Html' : 'Tekstowy') + "\n              ")])])])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Treść szablonu\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "template-pre"
  }, [_vm._v("\n          " + _vm._s(_vm.item.body) + "\n      ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-pagination"
  }, [_c('ui-button', {
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "keyboard_arrow_left",
      "disabled": _vm.meta.current_page <= 1
    },
    on: {
      "click": function($event) {
        _vm.setPage(_vm.meta.current_page - 1)
      }
    }
  }), _vm._v(" Strona: "), _c('span', [_vm._v(_vm._s(_vm.meta.current_page))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.meta.last_page))]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "default",
      "type": "normal",
      "icon": "keyboard_arrow_right",
      "disabled": _vm.meta.current_page >= _vm.meta.last_page
    },
    on: {
      "click": function($event) {
        _vm.setPage(_vm.meta.current_page + 1)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Rekordów: " + _vm._s(_vm.meta.total))]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "limit"
    },
    on: {
      "change": _vm.setLimit
    }
  }, _vm._l((_vm.meta.limits), function(l) {
    return _c('option', [_vm._v("\n        " + _vm._s(l) + "\n      ")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Adresy e-mail\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.import'
        })
      }
    }
  }, [_vm._v("Importuj adresy e-mail")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "file_download",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.export-emails'
        })
      }
    }
  }, [_vm._v("Eksportuj adresy e-mail")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.dashboard'
        })
      }
    }
  }, [_vm._v("Grupy adresów")])], 1), _vm._v(" "), _c('emails-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uix-list"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ui-select', {
    attrs: {
      "name": _vm.name,
      "label": _vm.label,
      "keys": _vm.keys,
      "value": _vm.model,
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "multiple": true,
      "required": _vm.required
    },
    on: {
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.first_name) + " " + _vm._s(_vm.item.last_name) + "\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('users-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Konta do wysyłania\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.accounts.create'
        })
      }
    }
  }, [_vm._v("Dodaj konto")])], 1), _vm._v(" "), _c('accounts-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dodaj wiadomość\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")])], 1), _vm._v(" "), _c('messages-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Grupy\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.create'
        })
      }
    }
  }, [_vm._v("Dodaj grupę")])], 1), _vm._v(" "), _c('email-groups-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uix-panel"
  }, [_c('div', {
    staticClass: "uix-panel-header",
    class: {
      collapsible: _vm.collapsible, show: _vm.show
    },
    on: {
      "click": _vm.tooglePanel
    }
  }, [_c('div', {
    staticClass: "uix-panel-actions"
  }, [_vm._t("actions")], 2), _vm._v(" "), _vm._t("header")], 2), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "uix-panel-body"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(konto do wysyłania)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.test
    }
  }, [_vm._v("Testuj konto")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj konto")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "fifty"
  }, [_vm._v("\n                  Nazwa wysyłającego wiadomości\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.from_name) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Adres e-mail z jakiego będą wychodzić wiadomości\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.from_address) + "\n              ")])])])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Konto smtp\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "fifty"
  }, [_vm._v("\n                  Host\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.host) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Port\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.port) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Host\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.host) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Nazwa użytkownika\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.username) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Hasło\n              ")]), _vm._v(" "), _c('td', [_c('ui-button', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showPassword = !_vm.showPassword
      }
    }
  }, [_vm._v("pokaż / zakryj")]), _vm._v(" "), (_vm.showPassword) ? _c('span', [_vm._v(_vm._s(_vm.item.password))]) : _vm._e(), _vm._v(" "), (!_vm.showPassword) ? _c('span', [_vm._v("****")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Limit wysyłania\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "fifty"
  }, [_vm._v("\n                  Limit wysyłanych wiadomości za jednym razem\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.item.limit) + "\n              ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dashboard\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-full grid-pad"
  }, [_c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Wiadomości")])]), _vm._v(" "), _vm._l((_vm.newslettersMenu), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Grupy i adresy e-mail")])]), _vm._v(" "), _vm._l((_vm.emailsMenu), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Administracja")])]), _vm._v(" "), _vm._l((_vm.adminMenu), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "important-line"
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dodaj e-mail\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")])], 1), _vm._v(" "), _c('emails-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.items), function(item, index) {
    return _c('simple-menu', {
      key: index,
      staticClass: "menu-left",
      attrs: {
        "header": item.header,
        "items": item.items
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.success) ? _c('div', {
    staticClass: "short-page"
  }, [_c('ui-alert', {
    attrs: {
      "dismissible": false
    }
  }, [_vm._v("Zostałeś wylogowany! Miłego dnia")]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Wylogowano poprawnie")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("Zaloguj sie ponownie")])], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dodaj konto do wysyłania\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do kont")])], 1), _vm._v(" "), _c('accounts-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "short-page"
  }, [(_vm.msg) ? _c('ui-alert', {
    attrs: {
      "type": "error",
      "dismissible": false
    }
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e(), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Zaloguj się")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ui-textbox', {
    attrs: {
      "label": "Twój e-mail",
      "name": "email",
      "type": "text",
      "autofocus": _vm.autofocus
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = $$v
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoje hasło",
      "name": "password",
      "type": "password"
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = $$v
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Zaloguj")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n        Nazwa\n        "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'name',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n        Grupa publiczna\n        "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'public',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n        Status\n        "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n        Akcje\n      ")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.email-groups.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "gray"
    }, [_vm._v("(" + _vm._s(item.total_emails) + ")")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.public ? 'Tak' : 'Nie'))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.status == 1 ? 'Aktywna' : 'Nie aktywna'))])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.email-groups.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "uix-list-item"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.title) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(wiadomość)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.show',
          params: {
            id: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('messages-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.users.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.first_name + ' ' + item.last_name))])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.users.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("\n        Imię i nazwisko\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Akcje\n      ")])])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stats.total == _vm.stats.success) ? _c('p', [_vm._v("\n    Wysłano poprawnie do wszystkich: "), _c('strong', [_vm._v(_vm._s(_vm.stats.total))]), _vm._v(" subskrybentów!\n  ")]) : _vm._e(), _vm._v(" "), (_vm.stats.total != _vm.stats.success) ? _c('p', [_vm._v("\n      Próbowano wysłać do "), _c('strong', [_vm._v(_vm._s(_vm.stats.total))]), _vm._v(". Wysłano z powodzeniem: "), _c('strong', [_vm._v(_vm._s(_vm.stats.success))]), _vm._v(".Nie można było wysłać do "), _c('strong', [_vm._v(_vm._s(_vm.stats.failure))]), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                E-mail\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n                Wysłano\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'send_on',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Status\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'send_status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.email.email) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.send_on_formated) + "\n            ")]), _vm._v(" "), _c('td', [(item.send_status == 1) ? _c('span', {
      staticClass: "badge badge-gray"
    }, [_vm._v("Wysłano")]) : _vm._e(), _vm._v(" "), (item.send_status != 1) ? _c('span', {
      staticClass: "badge badge-alert"
    }, [_vm._v("Nie można było wysłać")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(grupa)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.email-groups.show',
          params: {
            id: _vm.item.id
          }
        })
      }
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('email-groups-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ui-textbox', {
    attrs: {
      "label": "Nazwa",
      "name": "name",
      "type": "text",
      "autofocus": _vm.autofocus,
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.item.name = $$v
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "template_type",
      "label": "Typ szablonu",
      "options": _vm.templateTypes,
      "placeholder": "Wybierz typ szablonu",
      "required": ""
    },
    model: {
      value: (_vm.item.template_type),
      callback: function($$v) {
        _vm.item.template_type = $$v
      },
      expression: "item.template_type"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść szablonu",
      "name": "body",
      "type": "text",
      "rows": 10,
      "multi-line": true
    },
    model: {
      value: (_vm.item.body),
      callback: function($$v) {
        _vm.item.body = $$v
      },
      expression: "item.body"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          " + _vm._s(_vm.item.title) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(wiadomość)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getItem(_vm.item.id)
      }
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary",
      "disabled": _vm.item.status != 1
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.messages.edit',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "highlight_off",
      "color": "danger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.remove(_vm.item)
      }
    }
  }, [_vm._v("Usuń")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', [_vm._v("\n            Podgląd\n          ")]), _vm._v(" "), _c('td', [_c('ui-button', {
    attrs: {
      "icon": "mode_edit",
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.preview(_vm.item.id, 'html')
      }
    }
  }, [_vm._v("Podgląd wiadomości (html)")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "icon": "mode_edit",
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.preview(_vm.item.id, 'text')
      }
    }
  }, [_vm._v("Podgląd wiadomości (text)")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                  Status\n              ")]), _vm._v(" "), _c('td', [_c('message-status', {
    attrs: {
      "status": _vm.item.status
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getItem(_vm.item.id)
      }
    }
  })], 1)]), _vm._v(" "), (_vm.item.id) ? _c('tr', [_c('th', [_vm._v("\n                  Konto\n              ")]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.accounts.show',
          params: {
            id: _vm.item.email_account.id
          }
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.item.email_account.name))])])]) : _vm._e(), _vm._v(" "), (_vm.item.id) ? _c('tr', [_c('th', [_vm._v("\n                  Adresaci\n              ")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                      Wysyłka do:\n                      "), _c('message-send-to-info', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n                      W grupach: "), _vm._l((_vm.item.email_groups), function(g) {
    return _c('a', {
      staticClass: "badge",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.email-groups.show',
            params: {
              id: g.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(g.name))])
  })], 2), _vm._v(" "), (_vm.item.status == 1) ? _c('div', [(_vm.toSendTotal) ? _c('p', [_vm._v("\n                      Ilość subskrybentów którym zostanie wysłana wiadomość: "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.toSendTotal))]), _c('br'), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.showSubscribers()
      }
    }
  }, [_vm._v("Pokaż sybskrybentów")])], 1) : _vm._e(), _vm._v(" "), (_vm.toSendTotal == 0) ? _c('ui-alert', {
    attrs: {
      "type": "warning",
      "icon": "warning",
      "dismissible": false
    }
  }, [_vm._v("Ta wiadomość nie zostanie do nikogo wysłana!")]) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.item.use_template) ? _c('tr', [_c('th', [_vm._v("\n                  Używa szablonu\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                  Szablon html: "), _c('strong', [_vm._v(_vm._s(_vm.item.template_html ? _vm.item.template_html : 'Domyślny'))]), _c('br'), _vm._v(" Szablon tekstowy: "), _c('strong', [_vm._v(_vm._s(_vm.item.template_text ? _vm.item.template_text : 'Domyślny'))])])]) : _vm._e()])]), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Wyślij testowo wiadomość na podany niżej e-mail\n      ")]), _vm._v(" "), _c('message-test-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), (_vm.item.status == 3 || _vm.item.status == 4) ? _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n          Status wysyłki\n      ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reload($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.item.id) ? _c('messages-send-log', {
    attrs: {
      "id": _vm.item.id
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('ui-modal', {
    ref: "modal1",
    attrs: {
      "title": _vm.modal.title,
      "hide-footer": true,
      "size": "large"
    }
  }, [(_vm.item.id) ? _c('messages-send-to-list', {
    attrs: {
      "id": _vm.item.id
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uix-tree-selected"
  }, [(_vm.selected.id) ? _c('ui-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "highlight_off"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearSelected($event)
      }
    }
  }, [_vm._v("Usuń wybór")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [(_vm.selected.id) ? _c('strong', [_vm._v(_vm._s(_vm.selected.name))]) : _vm._e(), _vm._v(" "), (!_vm.selected.id) ? _c('strong', [_vm._v("—")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "collapsible": ""
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("\n        Filtry\n    ")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "E-mail",
      "name": "name",
      "type": "text",
      "placeholder": "Wpisz część adresu e-mail"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "groups",
      "label": "Grupy",
      "options": _vm.groups,
      "placeholder": "Wybierz",
      "help-text": "E-maile które występują w przynajmniej jednej z zaznaczonych grup"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.groups_ids),
      callback: function($$v) {
        _vm.groups_ids = $$v
      },
      expression: "groups_ids"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "status",
      "label": "Status",
      "options": _vm.statuses,
      "placeholder": "Wybierz status"
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('ui-button', {
    on: {
      "click": _vm.filter
    }
  }, [_vm._v("Filtruj")]), _vm._v(" "), _c('ui-button', {
    on: {
      "click": _vm.removeFilter
    }
  }, [_vm._v("Usuń filtry")])], 1)
},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adres url")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres url",
      "name": "url",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz adres url"
    },
    on: {
      "change": _vm.changed
    },
    model: {
      value: (_vm.url),
      callback: function($$v) {
        _vm.url = $$v
      },
      expression: "url"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Podgląd treści")]), _vm._v(" "), (_vm.iframeUrl) ? _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "width": "100%",
      "height": "300px;",
      "src": _vm.iframeUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.url
    }
  }, [_vm._v("Wybierz")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "uix-list-item-header"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.item.first_name + ' ' + _vm.item.last_name) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(administrator)")])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.users.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do administratorów")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edytuj administratora")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                Imię i nazwisko\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.item.first_name + ' ' + _vm.item.last_name) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                E-mail\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.item.email) + "\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Zmień swoje hasło")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ui-textbox', {
    attrs: {
      "label": "Twoje hasło",
      "name": "password",
      "type": "password",
      "validation-rules": "required|min:6|max:16",
      "validation-messages": _vm.errorMessages,
      "autocomplete": "off",
      "help-text": "Wybierz nowe hasło które ma minimum 6 znaków i maksimum 18"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoje hasło (powtórz)",
      "name": "password2",
      "type": "password",
      "validation-rules": "required|min:6|max:16",
      "validation-messages": _vm.errorMessages,
      "autocomplete": "off",
      "help-text": "Powtórz hasło wpisane wyżej"
    },
    model: {
      value: (_vm.form.password2),
      callback: function($$v) {
        _vm.form.password2 = $$v
      },
      expression: "form.password2"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Zmień hasło")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.my'
        })
      }
    }
  }, [_vm._v("Anuluj")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Podstawowe dane")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoja nazwa tego konta",
      "name": "name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.item.name = $$v
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail z jakiego będą wychodzić wiadomości",
      "name": "from_address",
      "type": "text",
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Adres e-mail z jakiego będą wychodzić wiadomości"
    },
    model: {
      value: (_vm.item.from_address),
      callback: function($$v) {
        _vm.item.from_address = $$v
      },
      expression: "item.from_address"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Nazwa wysyłającego wiadomości",
      "name": "from_name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Nazwa wysyłającego wiadomości"
    },
    model: {
      value: (_vm.item.from_name),
      callback: function($$v) {
        _vm.item.from_name = $$v
      },
      expression: "item.from_name"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dane konta smtp")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Serwer",
      "name": "host",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę serwera np. mail.twoja-domena.com"
    },
    model: {
      value: (_vm.item.host),
      callback: function($$v) {
        _vm.item.host = $$v
      },
      expression: "item.host"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Port",
      "name": "port",
      "type": "number",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę serwera np.: mail.twoja-domena.com"
    },
    model: {
      value: (_vm.item.port),
      callback: function($$v) {
        _vm.item.port = $$v
      },
      expression: "item.port"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Nazwa użytkownika",
      "name": "username",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwę użytkownika np. user@mail.twoja-domena.com"
    },
    model: {
      value: (_vm.item.username),
      callback: function($$v) {
        _vm.item.username = $$v
      },
      expression: "item.username"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Hasło użytkownika",
      "name": "password",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz hasło użytkownika"
    },
    model: {
      value: (_vm.item.password),
      callback: function($$v) {
        _vm.item.password = $$v
      },
      expression: "item.password"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Szyfrowanie",
      "name": "encryption",
      "type": "text",
      "placeholder": "Wpisz szyfrowanie np.: tls",
      "help-text": "Zostaw pole puste lub wpisz tls"
    },
    model: {
      value: (_vm.item.encryption),
      callback: function($$v) {
        _vm.item.encryption = $$v
      },
      expression: "item.encryption"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Limit wysyłania")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Limit wysyłanych wiadomości za jednym razem",
      "name": "limit",
      "type": "number",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz limit wysyłanych wiadomości np.: 100",
      "help-text": "Warto ustawić tą wartość na małą liczbę np. 100 i zwiększać gdy nie ma żadnych kłopotów"
    },
    model: {
      value: (_vm.item.limit),
      callback: function($$v) {
        _vm.item.limit = $$v
      },
      expression: "item.limit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                Tytuł\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'title',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Status\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Utworzono\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'created_at',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Adresaci\n            ")]), _vm._v(" "), _c('th', [_vm._v("\n                Akcje\n            ")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.messages.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('td', [_c('message-status', {
      attrs: {
        "status": item.status
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.created_at_formated) + "\n            ")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                    Wysyłka do:\n                    "), _c('message-send-to-info', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n                    W grupach: "), _vm._l((item.email_groups), function(g) {
      return _c('a', {
        staticClass: "badge",
        on: {
          "click": function($event) {
            _vm.$router.push({
              name: 'admin.email-groups.show',
              params: {
                id: g.id
              }
            })
          }
        }
      }, [_vm._v(_vm._s(g.name))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary",
        "disabled": item.status != 1
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.messages.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(this.item.status == 2) ? _c('span', {
    staticClass: "label-info"
  }, [_vm._v("Wypisany")]) : _vm._e(), _vm._v(" "), (this.item.status == 1) ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Potwierdzony")]) : _vm._e(), _vm._v(" "), (this.item.status == 0) ? _c('span', {
    staticClass: "label-alert"
  }, [_vm._v("Nie potwierdzony")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        Eksport adresów e-mail do pliku .csv\n    ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary",
      "icon": "navigate_before"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")])], 1), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "separator",
      "label": "Separator",
      "keys": _vm.keysForSelect,
      "default": _vm.default_separator,
      "options": _vm.separators,
      "placeholder": "Wybierz separator",
      "required": ""
    },
    model: {
      value: (_vm.separator),
      callback: function($$v) {
        _vm.separator = $$v
      },
      expression: "separator"
    }
  }), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "groups",
      "label": "Grupa",
      "keys": _vm.keysForSelect,
      "options": _vm.groups,
      "search-placeholder": "Szukaj",
      "show-search": true,
      "placeholder": "Wybierz grupy które chcesz eksportować"
    },
    model: {
      value: (_vm.email_groups),
      callback: function($$v) {
        _vm.email_groups = $$v
      },
      expression: "email_groups"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "icon": "file_download"
    }
  }, [_vm._v("Eksportuj adresy")])], 1)], 2)])
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Szablony\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.templates.create'
        })
      }
    }
  }, [_vm._v("Dodaj szablon")])], 1), _vm._v(" "), _c('templates-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Dodaj administratora\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.users.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do administratorów")])], 1), _vm._v(" "), _c('users-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail",
      "name": "email",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz adres e-mail"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.item.email = $$v
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "groups",
      "label": "Grupy",
      "keys": _vm.keysForSelect,
      "options": _vm.groups,
      "search-placeholder": "Szukaj",
      "show-search": true,
      "placeholder": "Wybierz grupy",
      "required": ""
    },
    model: {
      value: (_vm.item.groups_ids),
      callback: function($$v) {
        _vm.item.groups_ids = $$v
      },
      expression: "item.groups_ids"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.name) + "\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('accounts-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Stwórz szablon\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.templates.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć do szablonów")])], 1), _vm._v(" "), _c('templates-form', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.msgs), function(msg) {
    return _c('span', {
      staticClass: "badge send-to-info"
    }, [_vm._v(_vm._s(msg))])
  }))
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.accounts.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n          " + _vm._s(item.from_name)), _c('br'), _vm._v("\n        <" + _vm._s(item.from_address) + ">\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Host: "), _c('strong', [_vm._v(_vm._s(item.host))]), _c('br'), _vm._v("\n          Port: "), _c('strong', [_vm._v(_vm._s(item.port))]), _c('br'), _vm._v("\n          Nazwa użytkownika: "), _c('strong', [_vm._v(_vm._s(item.username))])])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.accounts.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("\n        Nazwa\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Dane konta\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Akcje\n      ")])])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.item.name) + "\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "color": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Anuluj")])], 1), _vm._v(" "), (_vm.item.id) ? _c('templates-form', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error"
      },
      on: {
        "dismiss": function($event) {
          _vm.dismissErrors()
        }
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "E-mail",
      "name": "email",
      "type": "text",
      "autofocus": _vm.autofocus,
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz e-mail"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.item.email = $$v
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Imię",
      "name": "first_name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz imię"
    },
    model: {
      value: (_vm.item.first_name),
      callback: function($$v) {
        _vm.item.first_name = $$v
      },
      expression: "item.first_name"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Nazwisko",
      "name": "last_name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwisko"
    },
    model: {
      value: (_vm.item.last_name),
      callback: function($$v) {
        _vm.item.last_name = $$v
      },
      expression: "item.last_name"
    }
  }), _vm._v(" "), (!this.item.id) ? _c('div', [_c('ui-textbox', {
    attrs: {
      "label": "Hasło",
      "name": "password",
      "type": "password",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz hasło"
    },
    model: {
      value: (_vm.item.password),
      callback: function($$v) {
        _vm.item.password = $$v
      },
      expression: "item.password"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Hasło (wpisz ponownie)",
      "name": "password2",
      "type": "password",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz hasło ponownie"
    },
    model: {
      value: (_vm.item.password2),
      callback: function($$v) {
        _vm.item.password2 = $$v
      },
      expression: "item.password2"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ckeditor"
  }, [_c('textarea', {
    attrs: {
      "id": _vm.id
    },
    domProps: {
      "value": _vm.value
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adresat")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail adresata",
      "name": "send_to",
      "type": "text",
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz e-mail adresata wiadomości"
    },
    model: {
      value: (_vm.message.send_to),
      callback: function($$v) {
        _vm.message.send_to = $$v
      },
      expression: "message.send_to"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Wiadomość ")]), _vm._v(" "), _c('p', [_c('ui-button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.fill($event)
      }
    }
  }, [_vm._v("Wypełnij przykładową treścią")])], 1), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tytuł wiadomości",
      "name": "title",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz tytuł wiadomości"
    },
    model: {
      value: (_vm.message.title),
      callback: function($$v) {
        _vm.message.title = $$v
      },
      expression: "message.title"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść wiadomości (treść tekstowa)",
      "name": "text_body",
      "type": "text",
      "placeholder": "Wpisz treść tekstową tej wiadomości",
      "multi-line": "",
      "rows": 8,
      "help-text": "Wpisz treść tekstową bez znaczników html"
    },
    model: {
      value: (_vm.message.text_body),
      callback: function($$v) {
        _vm.message.text_body = $$v
      },
      expression: "message.text_body"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść wiadomości (treść html)",
      "name": "html_body",
      "type": "text",
      "placeholder": "Wpisz treść html tej wiadomości",
      "multi-line": "",
      "rows": 8,
      "help-text": "Wpisz treść html tej wiadomości"
    },
    model: {
      value: (_vm.message.html_body),
      callback: function($$v) {
        _vm.message.html_body = $$v
      },
      expression: "message.html_body"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Wyślij testową wiadomość")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "uix-list"
  }, [_c('li', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.header))])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: item.route
          })
        }
      }
    }, [_vm._v(_vm._s(item.text))])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.templates.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.template_type))])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.templates.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("\n        Nazwa\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Typ\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        Akcje\n      ")])])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "use_template"
    },
    model: {
      value: (_vm.item.use_template),
      callback: function($$v) {
        _vm.item.use_template = $$v
      },
      expression: "item.use_template"
    }
  }, [_vm._v("Użyj szablonu")]), _vm._v(" "), (_vm.item.use_template) ? _c('p', [_vm._v("\n          Treść wiadomości zostanie wpisana do wybranego szablonu lub do domyślnego szablonu jeśli nie wybierzesz szablonu.\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.item.use_template) ? _c('div', [_c('p', [_vm._v("\n              Ponieważ nie wybrałeś \"użyj szablonu\" musisz zadbać o to aby cała wiadomość html była kompletna (była kompletną podstroną html - zawierała znaczniki html, body, head oraz link do wypisania się z newslettera).\n          ")]), _vm._v(" "), _c('p', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleHelp($event)
      }
    }
  }, [_vm._v("Pokaż więcej informacji")])]), _vm._v(" "), (_vm.showHelp) ? _c('div', [_c('p', [_vm._v("\n                  Link do wypisania się z newslettera ")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "name": "help",
      "disabled": true
    },
    model: {
      value: (_vm.help),
      callback: function($$v) {
        _vm.help = $$v
      },
      expression: "help"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                Link do potwierdzenia adresu e-mail\n              ")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "name": "help2",
      "disabled": true
    },
    model: {
      value: (_vm.help2),
      callback: function($$v) {
        _vm.help2 = $$v
      },
      expression: "help2"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.import_html_url) ? _c('ui-textbox', {
    attrs: {
      "label": "Wybrany url z którego zaimportujemy treść",
      "name": "import_html_url",
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.item.import_html_url),
      callback: function($$v) {
        _vm.item.import_html_url = $$v
      },
      expression: "item.import_html_url"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.item.use_template) ? _c('fieldset', [_c('legend', [_vm._v("Szablon")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "template_text",
      "label": "Szablon tekstowy",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_text,
      "placeholder": "Wybierz szablon",
      "required": ""
    },
    model: {
      value: (_vm.item.template_text),
      callback: function($$v) {
        _vm.item.template_text = $$v
      },
      expression: "item.template_text"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "template_html",
      "label": "Szablon html",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_html,
      "placeholder": "Wybierz szablon",
      "required": ""
    },
    model: {
      value: (_vm.item.template_html),
      callback: function($$v) {
        _vm.item.template_html = $$v
      },
      expression: "item.template_html"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Treść wiadomości")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tytuł",
      "name": "title",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz tytuł wiadomości"
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.item.title = $$v
      },
      expression: "item.title"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść tekstowa",
      "name": "text_body",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz treść tekstową",
      "multi-line": true,
      "rows": 4
    },
    model: {
      value: (_vm.item.text_body),
      callback: function($$v) {
        _vm.item.text_body = $$v
      },
      expression: "item.text_body"
    }
  }), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "fullpage": !_vm.item.use_template,
      "value": _vm.item.html_body
    },
    on: {
      "input": _vm.inputC
    }
  }), _vm._v(" "), (!_vm.item.use_template) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.importUrl($event)
      }
    }
  }, [_vm._v("Importuj treść wiadomości z podanego adresu url")]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adresaci tej wiadomości")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_all"
    },
    model: {
      value: (_vm.item.send_to_all),
      callback: function($$v) {
        _vm.item.send_to_all = $$v
      },
      expression: "item.send_to_all"
    }
  }, [_vm._v("Wszyscy")]), _vm._v(" "), (!_vm.item.send_to_all) ? _c('div', [_c('ui-checkbox', {
    attrs: {
      "name": "send_to_confirmed"
    },
    model: {
      value: (_vm.item.send_to_confirmed),
      callback: function($$v) {
        _vm.item.send_to_confirmed = $$v
      },
      expression: "item.send_to_confirmed"
    }
  }, [_vm._v("Potwierdzone adresy e-mail")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_notconfirmed"
    },
    model: {
      value: (_vm.item.send_to_notconfirmed),
      callback: function($$v) {
        _vm.item.send_to_notconfirmed = $$v
      },
      expression: "item.send_to_notconfirmed"
    }
  }, [_vm._v("Niepotwierdzone adresy e-mail")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_imported"
    },
    model: {
      value: (_vm.item.send_to_imported),
      callback: function($$v) {
        _vm.item.send_to_imported = $$v
      },
      expression: "item.send_to_imported"
    }
  }, [_vm._v("Zaimportowani")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_signout"
    },
    model: {
      value: (_vm.item.send_to_signout),
      callback: function($$v) {
        _vm.item.send_to_signout = $$v
      },
      expression: "item.send_to_signout"
    }
  }, [_vm._v("Wypisani")])], 1) : _vm._e(), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "email_groups_ids",
      "label": "Grupy",
      "keys": _vm.keysForSelect,
      "options": _vm.emailGroups,
      "placeholder": "Wybierz grupy",
      "multiple": "",
      "search-placeholder": "Szukaj",
      "show-search": true,
      "required": ""
    },
    model: {
      value: (_vm.item.email_groups_ids),
      callback: function($$v) {
        _vm.item.email_groups_ids = $$v
      },
      expression: "item.email_groups_ids"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Konto z którego zostanie wysłana wiadomość")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "account",
      "label": "Konto do wysłania wiadomości",
      "keys": _vm.keysForSelect,
      "options": _vm.accounts,
      "placeholder": "Wybierz konto",
      "required": ""
    },
    model: {
      value: (_vm.item.email_account_id),
      callback: function($$v) {
        _vm.item.email_account_id = $$v
      },
      expression: "item.email_account_id"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Status")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "status",
      "label": "Status",
      "keys": _vm.keysForSelect,
      "options": _vm.statuses,
      "placeholder": "Wybierz status",
      "required": ""
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.item.status = $$v
      },
      expression: "item.status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2), _vm._v(" "), _c('ui-modal', {
    ref: "modal1",
    attrs: {
      "title": _vm.modal.title,
      "hide-footer": true,
      "size": "large"
    }
  }, [_c('url-preview-form', {
    on: {
      "choose": _vm.getUrl
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ui-select', {
    attrs: {
      "name": _vm.name,
      "label": _vm.label,
      "keys": _vm.keys,
      "value": _vm.model,
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "multiple": false,
      "required": _vm.required
    },
    on: {
      "input": _vm.onInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Wiadomości\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.messages.create'
        })
      }
    }
  }, [_vm._v("Dodaj wiadomość")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "refresh",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reload()
      }
    }
  })], 1), _vm._v(" "), _c('messages-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.item.email) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("(adres e-mail)")])]), _vm._v(" "), _c('table', {
    staticClass: "table info-table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "short"
  }, [_vm._v("\n                    Należy do grup\n                ")]), _vm._v(" "), _c('td', _vm._l((_vm.item.groups), function(g) {
    return _c('p', [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.email-groups.show',
            params: {
              id: g.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(g.name))])])
  }))]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                    Status\n                ")]), _vm._v(" "), _c('td', [(_vm.item) ? _c('email-status', {
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                    Zaimportowany\n                ")]), _vm._v(" "), _c('td', [(_vm.item.was_imported) ? _c('div', [_c('span', {
    staticClass: "label-black"
  }, [_vm._v("Tak.")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.imported_at_formated))])]) : _vm._e(), _vm._v(" "), (!_vm.item.was_imported) ? _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Nie")])]) : _vm._e()])])])]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "navigate_before",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.dashboard'
        })
      }
    }
  }, [_vm._v("Wróć")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "mode_edit",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.emails.edit',
          params: {
            id: _vm.id
          }
        })
      }
    }
  }, [_vm._v("Edytuj adres e-mail")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[42]);


// WEBPACK FOOTER //
// static/js/app.9115dac42c67f51f2c13.js